/**
 * 🌐 ALGOLIA TRANSLATIONS - Centralized Translation System
 * Updated & Normalized
 */

window.AlgoliaTranslations = {
  IT: {
    no_products_found: "Nessun prodotto trovato",
    no_products_in_collection: "Non ci sono prodotti in questa collezione attualmente.",
    try_changing_filters: "Prova a modificare i filtri per vedere più prodotti.",
    clear_filters: "Cancella filtri",
    resetAll: "Cancella",
    Italy: "Italia",
    France: "Francia",
    Germany: "Germania",
    Spain: "Spagna",
    "United Kingdom": "Regno Unito",
    Argentina: "Argentina",
    "United States of America": "Stati Uniti",
    "South Africa": "Sudafrica",
    "Caribbean Sea": "Mar dei Caraibi",
    "New Zealand": "Nuova Zelanda",
    Japan: "Giappone",
    Portugal: "Portogallo",
    Slovenia: "Slovenia",
    Chile: "Cile",
    Austria: "Austria",
    Australia: "Australia",
    Hungary: "Ungheria",
    Netherlands: "Paesi Bassi",
    Venezuela: "Venezuela",
    Mexico: "Messico",
    Uruguay: "Uruguay",
    Armenia: "Armenia",
    "Canary Islands": "Isole Canarie",
    India: "India",
    Sweden: "Svezia",
    Switzerland: "Svizzera",
    Greece: "Grecia",
    Ireland: "Irlanda",
    Lebanon: "Libano",
    Taiwan: "Taiwan",
    Belgium: "Belgio",
    Brazil: "Brasile",
    China: "Cina",
    Croatia: "Croazia",
    "Czech Republic": "Repubblica Ceca",
    Guatemala: "Guatemala",
    Norway: "Norvegia",
    Philippines: "Filippine",
    Poland: "Polonia",
    Russia: "Russia",
    Israel: "Israele",
    // Regioni
    Tuscany: "Toscana",
    Piedmont: "Piemonte",
    Burgundy: "Borgogna",
    Bordeaux: "Bordeaux",
    "Rhone Valley": "Valle del Rodano",
    Mendoza: "Mendoza",
    California: "California",
    Beaujolais: "Beaujolais",
    Rioja: "Rioja",
    Loire: "Loira",
    Jura: "Jura",
    "Uco Valley": "Valle de Uco",
    "Castile and León": "Castiglia e León",
    Catalonia: "Catalogna",
    Galicia: "Galizia",
    "Maipo Valley": "Maipo Valley",
    "Champagne region": "Champagne",
    "Colchagua Valley": "Colchagua Valley",
    "Barossa Valley": "Barossa Valley",
    "South Australia": "Australia Meridionale",
    "South West": "Sud-Ovest",
    "Valle de Cafayate": "Valle de Cafayate",
    Alsace: "Alsazia",
    "Rapel Valley": "Rapel Valley",
    Navarre: "Navarra",
    Provence: "Provenza",
    Savoy: "Savoia",
    "Western Australia": "Australia Occidentale",
    "Aconcagua Valley": "Aconcagua Valley",
    "Bekaa Valley": "Bekaa Valley",
    "Casablanca Valley": "Casablanca Valley",
    "Maule Valley": "Maule Valley",
    "Languedoc-Roussillon": "Linguadoca-Rossiglione",
    "Trentino Alto Adige": "Trentino-Alto Adige",
    Veneto: "Veneto",
    "Friuli-Venezia Giulia": "Friuli-Venezia Giulia",
    Lombardy: "Lombardia",
    Sicily: "Sicilia",
    "Emilia-Romagna": "Emilia-Romagna",
    Apulia: "Puglia",
    Marche: "Marche",
    Campania: "Campania",
    Abruzzo: "Abruzzo",
    Sardinia: "Sardegna",
    Umbria: "Umbria",
    Liguria: "Liguria",
    "Aosta Valley": "Valle d'Aosta",
    Lazio: "Lazio",
    Calabria: "Calabria",
    Basilicata: "Basilicata",
    Molise: "Molise",
    "Blend Red": "Blend rosso",
    "Blend White": "Blend bianco",
    searchPlaceholder: "Cerca prodotti...",
    results: "Risultati",
    noResults: "Nessun risultato trovato",
    loading: "Caricamento...",
    showMore: "Mostra altro",
    showLess: "Mostra meno",
    filters: "Filtri",
    clearFilters: "Cancella filtri",
    applyFilters: "Applica filtri",
    sortBy: "Ordina per",
    relevance: "Pertinenza",
    priceAsc: "Prezzo: dal più basso",
    priceDesc: "Prezzo: dal più alto",
    nameAsc: "Nome: A-Z",
    nameDesc: "Nome: Z-A",
    products: "Prodotti",
    productsCount: "{count} prodotti",
    product: "Prodotto",
    addToCart: "Aggiungi al carrello",
    viewProduct: "Vedi prodotto",
    outOfStock: "Esaurito",
    inStock: "Disponibile",
    price: "Prezzo",
    vendor: "Produttore",
    category: "Categoria",
    collection: "Collezione",
    tag: "Tag",
    color: "Colore",
    size: "Formato",
    material: "Materiale",
    brand: "Brand",
    type: "Tipo",
    availability: "Disponibilità",
    rating: "Valutazione",
    reviews: "Recensioni",
    review: "Recensione",
    compare: "Confronta",
    wishlist: "Lista desideri",
    quickView: "Anteprima veloce",
    newArrival: "Nuovi Arrivi",
    sale: "In saldo",
    bestseller: "Più venduti",
    featured: "In evidenza",
    recommended: "Consigliati",
    trending: "Di tendenza",
    popular: "Popolari",
    popularSearches: "Ricerche popolari",
    topRated: "Più votati",
    discount: "Sconto",
    free: "Gratis",
    shipping: "Spedizione",
    freeShipping: "Spedizione gratuita",
    returns: "Resi",
    freeReturns: "Resi gratuiti",
    warranty: "Garanzia",
    secure: "Sicuro",
    payment: "Pagamento",
    securePayment: "Pagamento sicuro",
    checkout: "Checkout",
    cart: "Carrello",
    account: "Account",
    login: "Accedi",
    logout: "Esci",
    register: "Registrati",
    forgotPassword: "Password dimenticata?",
    myAccount: "Il mio account",
    myOrders: "I miei ordini",
    myAddresses: "I miei indirizzi",
    myWishlist: "La mia lista desideri",
    myReviews: "Le mie recensioni",
    settings: "Impostazioni",
    help: "Aiuto",
    contact: "Contatti",
    faq: "FAQ",
    about: "Chi siamo",
    terms: "Termini e condizioni",
    privacy: "Privacy",
    cookies: "Cookie",
    countries: "Paesi",
    regions: "Regioni",
    vendors: "Produttori",
    producers: "Produttori",
    appellations: "Denominazioni",
    grapes: "Vitigni",
    onSale: "In Promozione",
    bestSeller: "Più venduti",
    mostAwarded: "Più Premiati",
    newIn: "Novità",
    activeFilters: "Filtri attivi:",
    clearAll: "Cancella tutto",
    showAllResults: "Mostra tutti i {count} risultati",
    results: "Risultati",
    resultsFor: 'Risultati per: "{query}"',
    preorder: "Preordina",
    productsFound: "{count} prodotti trovati",
    allProducts: "Tutti i prodotti",
    BB: "Guida della Fondazione Italiana Sommelier (FIS). Da oltre 10 anni è una delle guide enologiche più prestigiose d'Italia.",
    DE: "Decanter è una rivista di vino e lifestyle, pubblicata mensilmente in circa 90 paesi. Include notizie di settore, guide classiche e consigli su vino e liquori.",
    RP: "La prestigiosa guida internazionale ai vini di Robert Parker, il degustatore più esperto e fidato al mondo.",
    LM: "Una delle guide enologiche più prestigiose d'Italia.",
    GR: "Guida molto apprezzata che offre la più completa rassegna dei vini italiani. Vanta una lunga tradizione e si basa su degustazioni alla cieca condotte da oltre 100 esperti.",
    VR: "Una delle guide enologiche più prestigiose d'Italia.",
    VT: "Guida dell'Associazione Italiana Sommelier (AIS).",
    VO: "Vinous è la guida online di Antonio Galloni, uno dei maggiori intenditori di vino al mondo.",
    WS: "Wine Spectator è la guida enologica più influente su Internet.",
    SL: "",
    XW: "",
    HC: "La guida definitiva ai vini francesi.",
    JS: "James Suckling è un influente critico enologico e giornalista americano. Ha lavorato per Wine Spectator per 30 anni prima di fondare JamesSuckling.com. È specializzato in vini italiani e di Bordeaux.",
    lowestPrice: "Prezzo più basso",
    lowestPriceText:
      "È il prezzo più basso a cui il prodotto era in vendita nei 30 giorni precedenti la riduzione del prezzo.",
  },
  FR: {
    no_products_found: "Aucun produit trouvé",
    no_products_in_collection: "Il n'y a pas de produits dans cette collection actuellement.",
    try_changing_filters: "Essayez de modifier les filtres pour voir plus de produits.",
    clear_filters: "Effacer les filtres",
    resetAll: "Réinitialiser",
    Italy: "Italie",
    France: "France",
    Germany: "Allemagne",
    Spain: "Espagne",
    "United Kingdom": "Royaume-Uni",
    Argentina: "Argentine",
    "United States of America": "États-Unis",
    "South Africa": "Afrique du Sud",
    "Caribbean Sea": "Mer des Caraïbes",
    "New Zealand": "Nouvelle-Zélande",
    Japan: "Japon",
    Portugal: "Portugal",
    Slovenia: "Slovénie",
    Chile: "Chili",
    Austria: "Autriche",
    Australia: "Australie",
    Hungary: "Hongrie",
    Netherlands: "Pays-Bas",
    Venezuela: "Venezuela",
    Mexico: "Mexique",
    Uruguay: "Uruguay",
    Armenia: "Arménie",
    "Canary Islands": "Îles Canaries",
    India: "Inde",
    Sweden: "Suède",
    Switzerland: "Suisse",
    Greece: "Grèce",
    Ireland: "Irlande",
    Lebanon: "Liban",
    Taiwan: "Taïwan",
    Belgium: "Belgique",
    Brazil: "Brésil",
    China: "Chine",
    Croatia: "Croatie",
    "Czech Republic": "République tchèque",
    Guatemala: "Guatemala",
    Norway: "Norvège",
    Philippines: "Philippines",
    Poland: "Pologne",
    Russia: "Russie",
    Israel: "Israël",
    Tuscany: "Toscane",
    Piedmont: "Piémont",
    Burgundy: "Bourgogne",
    Bordeaux: "Bordeaux",
    "Rhone Valley": "Vallée du Rhône",
    Mendoza: "Mendoza",
    California: "Californie",
    Beaujolais: "Beaujolais",
    Rioja: "Rioja",
    Loire: "Loire",
    Jura: "Jura",
    "Uco Valley": "Vallée de Uco",
    "Castile and León": "Castille-et-León",
    Catalonia: "Catalogne",
    Galicia: "Galice",
    "Maipo Valley": "Vallée de Maipo",
    "Champagne region": "Champagne",
    "Colchagua Valley": "Vallée de Colchagua",
    "Barossa Valley": "Vallée Barossa",
    "South Australia": "Australie-Méridionale",
    "South West": "Sud-Ouest",
    "Valle de Cafayate": "Vallée de Cafayate",
    Alsace: "Alsace",
    "Rapel Valley": "Vallée de Rapel",
    Navarre: "Navarre",
    Provence: "Provence",
    Savoy: "Savoie",
    "Western Australia": "Australie-Occidentale",
    "Aconcagua Valley": "Vallée de l'Aconcagua",
    "Bekaa Valley": "Vallée de la Bekaa",
    "Casablanca Valley": "Vallée de Casablanca",
    "Maule Valley": "Vallée du Maule",
    "Languedoc-Roussillon": "Languedoc-Roussillon",
    "Trentino Alto Adige": "Trentin-Haut-Adige",
    Veneto: "Vénétie",
    "Friuli-Venezia Giulia": "Frioul-Vénétie Julienne",
    Lombardy: "Lombardie",
    Sicily: "Sicile",
    "Emilia-Romagna": "Émilie-Romagne",
    Apulia: "Pouilles",
    Marche: "Marches",
    Campania: "Campanie",
    Abruzzo: "Abruzzes",
    Sardinia: "Sardaigne",
    Umbria: "Ombrie",
    Liguria: "Ligurie",
    "Aosta Valley": "Vallée d'Aoste",
    Lazio: "Latium",
    Calabria: "Calabre",
    Basilicata: "Basilicate",
    Molise: "Molise",
    "Blend Red": "Assemblage rouge",
    "Blend White": "Assemblage blanc",
    searchPlaceholder: "Rechercher des produits...",
    results: "Résultats",
    noResults: "Aucun résultat trouvé",
    loading: "Chargement...",
    showMore: "Voir plus",
    showLess: "Voir moins",
    filters: "Filtres",
    clearFilters: "Effacer les filtres",
    applyFilters: "Appliquer les filtres",
    sortBy: "Trier par",
    relevance: "Pertinence",
    priceAsc: "Prix : croissant",
    priceDesc: "Prix : décroissant",
    nameAsc: "Nom : A-Z",
    nameDesc: "Nom : Z-A",
    products: "Produits",
    productsCount: "{count} produits",
    product: "Produit",
    addToCart: "Ajouter au panier",
    viewProduct: "Voir le produit",
    outOfStock: "Épuisé",
    inStock: "En stock",
    price: "Prix",
    vendor: "Vendeur",
    category: "Catégorie",
    collection: "Collection",
    tag: "Tag",
    color: "Couleur",
    size: "Format",
    material: "Matériau",
    brand: "Marque",
    type: "Type",
    availability: "Disponibilité",
    rating: "Note",
    reviews: "Avis",
    review: "Avis",
    compare: "Comparer",
    wishlist: "Liste de souhaits",
    quickView: "Aperçu rapide",
    newArrival: "Nouveautés",
    sale: "Promotions",
    bestseller: "Meilleures ventes",
    featured: "En vedette",
    recommended: "Recommandés",
    trending: "Tendance",
    popular: "Populaire",
    popularSearches: "Recherches populaires",
    topRated: "Mieux notés",
    discount: "Remise",
    free: "Gratuit",
    shipping: "Livraison",
    freeShipping: "Livraison gratuite",
    returns: "Retours",
    freeReturns: "Retours gratuits",
    warranty: "Garantie",
    secure: "Sécurisé",
    payment: "Paiement",
    securePayment: "Paiement sécurisé",
    checkout: "Commander",
    cart: "Panier",
    account: "Compte",
    login: "Connexion",
    logout: "Déconnexion",
    register: "S'inscrire",
    forgotPassword: "Mot de passe oublié ?",
    myAccount: "Mon compte",
    myOrders: "Mes commandes",
    myAddresses: "Mes adresses",
    myWishlist: "Ma liste de souhaits",
    myReviews: "Mes avis",
    settings: "Paramètres",
    help: "Aide",
    contact: "Contact",
    faq: "FAQ",
    about: "À propos",
    terms: "Conditions générales",
    privacy: "Confidentialité",
    cookies: "Cookies",
    countries: "Pays",
    regions: "Régions",
    vendors: "Vendeurs",
    producers: "Producteurs",
    appellations: "Appellations",
    grapes: "Cépages",
    onSale: "En Promotion",
    bestSeller: "Meilleures ventes",
    mostAwarded: "Les plus primés",
    newIn: "Nouveautés",
    activeFilters: "Filtres actifs :",
    clearAll: "Tout effacer",
    showAllResults: "Afficher les {count} résultats",
    resultsFor: 'Résultats pour : "{query}"',
    preorder: "Précommander",
    productsFound: "{count} produits trouvés",
    allProducts: "Tous les produits",
    BB: "Guide de la Fondation Italienne Sommelier (FIS). L'un des guides les plus prestigieux d'Italie depuis plus de 10 ans.",
    DE: "Decanter est un magazine lifestyle dédié au vin, publié dans environ 90 pays. Il propose actualités, guides et conseils.",
    RP: "Le prestigieux guide international de Robert Parker, le critique de vin le plus influent au monde.",
    LM: "L'un des guides de vins les plus prestigieux d'Italie.",
    GR: "Guide très respecté offrant la revue la plus complète des vins italiens, basé sur des dégustations à l'aveugle par plus de 100 experts.",
    VR: "L'un des guides de vins les plus prestigieux d'Italie.",
    VT: "Guide de l'Association Italienne des Sommeliers (AIS).",
    VO: "Vinous est le guide en ligne d'Antonio Galloni, l'un des plus grands experts en vin au monde.",
    WS: "Wine Spectator est le guide des vins le plus influent sur Internet.",
    SL: "",
    XW: "",
    HC: "Le guide ultime des vins français.",
    JS: "James Suckling est un critique influent, ancien de Wine Spectator. Son site JamesSuckling.com est spécialisé dans les vins italiens et bordelais.",
    lowestPrice: "Prix le plus bas",
    lowestPriceText:
      "Le prix le plus bas pratiqué au cours des 30 jours précédant la réduction, promotions incluses.",
  },
  DE: {
    no_products_found: "Keine Produkte gefunden",
    no_products_in_collection: "Es gibt keine Produkte in dieser Kollektion aktuell.",
    try_changing_filters: "Versuchen Sie, die Filter zu ändern, um mehr Produkte zu sehen.",
    clear_filters: "Filter löschen",
    resetAll: "Zurücksetzen",
    Italy: "Italien",
    France: "Frankreich",
    Germany: "Deutschland",
    Spain: "Spanien",
    "United Kingdom": "Vereinigtes Königreich",
    Argentina: "Argentinien",
    "United States of America": "Vereinigte Staaten",
    "South Africa": "Südafrika",
    "Caribbean Sea": "Karibisches Meer",
    "New Zealand": "Neuseeland",
    Japan: "Japan",
    Portugal: "Portugal",
    Slovenia: "Slowenien",
    Chile: "Chile",
    Austria: "Österreich",
    Australia: "Australien",
    Hungary: "Ungarn",
    Netherlands: "Niederlande",
    Venezuela: "Venezuela",
    Mexico: "Mexiko",
    Uruguay: "Uruguay",
    Armenia: "Armenien",
    "Canary Islands": "Kanarische Inseln",
    India: "Indien",
    Sweden: "Schweden",
    Switzerland: "Schweiz",
    Greece: "Griechenland",
    Ireland: "Irland",
    Lebanon: "Libanon",
    Taiwan: "Taiwan",
    Belgium: "Belgien",
    Brazil: "Brasilien",
    China: "China",
    Croatia: "Kroatien",
    "Czech Republic": "Tschechische Republik",
    Guatemala: "Guatemala",
    Norway: "Norwegen",
    Philippines: "Philippinen",
    Poland: "Polen",
    Russia: "Russland",
    Israel: "Israel",
    Tuscany: "Toskana",
    Piedmont: "Piemont",
    Burgundy: "Burgund",
    Bordeaux: "Bordeaux",
    "Rhone Valley": "Rhonetal",
    Mendoza: "Mendoza",
    California: "Kalifornien",
    Beaujolais: "Beaujolais",
    Rioja: "Rioja",
    Loire: "Loire",
    Jura: "Jura",
    "Uco Valley": "Uco-Tal",
    "Castile and León": "Kastilien und León",
    Catalonia: "Katalonien",
    Galicia: "Galicien",
    "Maipo Valley": "Maipo-Tal",
    "Champagne region": "Champagne",
    "Colchagua Valley": "Colchagua-Tal",
    "Barossa Valley": "Barossa Valley",
    "South Australia": "Südaustralien",
    "South West": "Südwestfrankreich",
    "Valle de Cafayate": "Cafayate-Tal",
    Alsace: "Elsass",
    "Rapel Valley": "Rapel-Tal",
    Navarre: "Navarra",
    Provence: "Provence",
    Savoy: "Savoyen",
    "Western Australia": "Westaustralien",
    "Aconcagua Valley": "Aconcagua-Tal",
    "Bekaa Valley": "Bekaa-Ebene",
    "Casablanca Valley": "Casablanca-Tal",
    "Maule Valley": "Maule-Tal",
    "Languedoc-Roussillon": "Languedoc-Roussillon",
    "Trentino Alto Adige": "Trentino-Südtirol",
    Veneto: "Venetien",
    "Friuli-Venezia Giulia": "Friaul-Julisch Venetien",
    Lombardy: "Lombardei",
    Sicily: "Sizilien",
    "Emilia-Romagna": "Emilia-Romagna",
    Apulia: "Apulien",
    Marche: "Marken",
    Campania: "Kampanien",
    Abruzzo: "Abruzzen",
    Sardinia: "Sardinien",
    Umbria: "Umbrien",
    Liguria: "Ligurien",
    "Aosta Valley": "Aostatal",
    Lazio: "Latium",
    Calabria: "Kalabrien",
    Basilicata: "Basilikata",
    Molise: "Molise",
    "Blend Red": "Rotweincuvée",
    "Blend White": "Weißweincuvée",
    searchPlaceholder: "Produkte suchen...",
    results: "Ergebnisse",
    noResults: "Keine Ergebnisse",
    loading: "Laden...",
    showMore: "Mehr anzeigen",
    showLess: "Weniger anzeigen",
    filters: "Filter",
    clearFilters: "Filter löschen",
    applyFilters: "Filter anwenden",
    sortBy: "Sortieren nach",
    relevance: "Relevanz",
    priceAsc: "Preis: aufsteigend",
    priceDesc: "Preis: absteigend",
    nameAsc: "Name: A-Z",
    nameDesc: "Name: Z-A",
    products: "Produkte",
    productsCount: "{count} Produkte",
    product: "Produkt",
    addToCart: "In den Warenkorb",
    viewProduct: "Zum Produkt",
    outOfStock: "Ausverkauft",
    inStock: "Auf Lager",
    price: "Preis",
    vendor: "Hersteller",
    category: "Kategorie",
    collection: "Kollektion",
    tag: "Tag",
    color: "Farbe",
    size: "Größe",
    material: "Material",
    brand: "Marke",
    type: "Typ",
    availability: "Verfügbarkeit",
    rating: "Bewertung",
    reviews: "Bewertungen",
    review: "Bewertung",
    compare: "Vergleichen",
    wishlist: "Wunschliste",
    quickView: "Schnellansicht",
    newArrival: "Neuheiten",
    sale: "Angebote",
    bestseller: "Bestseller",
    featured: "Highlights",
    recommended: "Empfohlen",
    trending: "Im Trend",
    popular: "Beliebt",
    popularSearches: "Beliebte Suchanfragen",
    topRated: "Bestbewertet",
    discount: "Rabatt",
    free: "Kostenlos",
    shipping: "Versand",
    freeShipping: "Kostenloser Versand",
    returns: "Retouren",
    freeReturns: "Kostenlose Retoure",
    warranty: "Garantie",
    secure: "Sicher",
    payment: "Zahlung",
    securePayment: "Sichere Zahlung",
    checkout: "Zur Kasse",
    cart: "Warenkorb",
    account: "Konto",
    login: "Anmelden",
    logout: "Abmelden",
    register: "Registrieren",
    forgotPassword: "Passwort vergessen?",
    myAccount: "Mein Konto",
    myOrders: "Meine Bestellungen",
    myAddresses: "Meine Adressen",
    myWishlist: "Meine Wunschliste",
    myReviews: "Meine Bewertungen",
    settings: "Einstellungen",
    help: "Hilfe",
    contact: "Kontakt",
    faq: "FAQ",
    about: "Über uns",
    terms: "AGB",
    privacy: "Datenschutz",
    cookies: "Cookies",
    countries: "Länder",
    regions: "Regionen",
    vendors: "Verkäufer",
    producers: "Produzenten",
    appellations: "Bezeichnungen",
    grapes: "Rebsorten",
    onSale: "Im Angebot",
    bestSeller: "Bestseller",
    mostAwarded: "Meistprämiert",
    newIn: "Neuheiten",
    activeFilters: "Aktive Filter:",
    clearAll: "Alle löschen",
    showAllResults: "Alle {count} Ergebnisse anzeigen",
    resultsFor: 'Ergebnisse für: "{query}"',
    preorder: "Vorbestellen",
    productsFound: "{count} Produkte gefunden",
    allProducts: "Alle Produkte",
    BB: "Leitfaden der Fondazione Italiana Sommelier (FIS). Seit über 10 Jahren einer der renommiertesten Weinführer Italiens.",
    DE: "Decanter ist ein Wein- und Lifestyle-Magazin, das in rund 90 Ländern erscheint. Es bietet Branchennews und Weinempfehlungen.",
    RP: "Der renommierte internationale Weinführer von Robert Parker, dem weltweit vertrauenswürdigsten Weinkritiker.",
    LM: "Einer der renommiertesten Weinführer Italiens.",
    GR: "Dieser hochangesehene Führer bietet den umfassendsten Überblick über italienische Weine, basierend auf Blindverkostungen von über 100 Experten.",
    VR: "Einer der renommiertesten Weinführer Italiens.",
    VT: "Leitfaden der Associazione Italiana Sommelier (AIS).",
    VO: "Vinous ist der Online-Guide von Antonio Galloni, einem der weltweit führenden Weinkenner.",
    WS: "Wine Spectator ist der einflussreichste Weinführer im Internet.",
    SL: "",
    XW: "",
    HC: "Der ultimative Führer zu französischen Weinen.",
    JS: "James Suckling ist ein einflussreicher US-Weinkritiker (ehemals Wine Spectator). Sein Portal JamesSuckling.com spezialisiert sich auf Italien und Bordeaux.",
    lowestPrice: "Niedrigster Preis",
    lowestPriceText:
      "Der niedrigste Preis der letzten 30 Tage vor der Preissenkung.",
  },
  EN: {
    no_products_found: "No products found",
    no_products_in_collection: "There are no products in this collection currently.",
    try_changing_filters: "Try changing the filters to see more products.",
    clear_filters: "Clear filters",
    resetAll: "Reset",
    Italy: "Italy",
    France: "France",
    Germany: "Germany",
    Spain: "Spain",
    "United Kingdom": "United Kingdom",
    Argentina: "Argentina",
    "United States of America": "United States",
    "South Africa": "South Africa",
    "Caribbean Sea": "Caribbean Sea",
    "New Zealand": "New Zealand",
    Japan: "Japan",
    Portugal: "Portugal",
    Slovenia: "Slovenia",
    Chile: "Chile",
    Austria: "Austria",
    Australia: "Australia",
    Hungary: "Hungary",
    Netherlands: "Netherlands",
    Venezuela: "Venezuela",
    Mexico: "Mexico",
    Uruguay: "Uruguay",
    Armenia: "Armenia",
    "Canary Islands": "Canary Islands",
    India: "India",
    Sweden: "Sweden",
    Switzerland: "Switzerland",
    Greece: "Greece",
    Ireland: "Ireland",
    Lebanon: "Lebanon",
    Taiwan: "Taiwan",
    Belgium: "Belgium",
    Brazil: "Brazil",
    China: "China",
    Croatia: "Croatia",
    "Czech Republic": "Czech Republic",
    Guatemala: "Guatemala",
    Norway: "Norway",
    Philippines: "Philippines",
    Poland: "Poland",
    Russia: "Russia",
    Israel: "Israel",
    Tuscany: "Tuscany",
    Piedmont: "Piedmont",
    Burgundy: "Burgundy",
    Bordeaux: "Bordeaux",
    "Rhone Valley": "Rhone Valley",
    Mendoza: "Mendoza",
    California: "California",
    Beaujolais: "Beaujolais",
    Rioja: "Rioja",
    Loire: "Loire",
    Jura: "Jura",
    "Uco Valley": "Uco Valley",
    "Castile and León": "Castile and León",
    Catalonia: "Catalonia",
    Galicia: "Galicia",
    "Maipo Valley": "Maipo Valley",
    "Champagne region": "Champagne",
    "Colchagua Valley": "Colchagua Valley",
    "Barossa Valley": "Barossa Valley",
    "South Australia": "South Australia",
    "South West": "South West",
    "Valle de Cafayate": "Valle de Cafayate",
    Alsace: "Alsace",
    "Rapel Valley": "Rapel Valley",
    Navarre: "Navarre",
    Provence: "Provence",
    Savoy: "Savoy",
    "Western Australia": "Western Australia",
    "Aconcagua Valley": "Aconcagua Valley",
    "Bekaa Valley": "Bekaa Valley",
    "Casablanca Valley": "Casablanca Valley",
    "Maule Valley": "Maule Valley",
    "Languedoc-Roussillon": "Languedoc-Roussillon",
    "Trentino Alto Adige": "Trentino-Alto Adige",
    Veneto: "Veneto",
    "Friuli-Venezia Giulia": "Friuli-Venezia Giulia",
    Lombardy: "Lombardy",
    Sicily: "Sicily",
    "Emilia-Romagna": "Emilia-Romagna",
    Apulia: "Puglia",
    Marche: "Marche",
    Campania: "Campania",
    Abruzzo: "Abruzzo",
    Sardinia: "Sardinia",
    Umbria: "Umbria",
    Liguria: "Liguria",
    "Aosta Valley": "Aosta Valley",
    Lazio: "Lazio",
    Calabria: "Calabria",
    Basilicata: "Basilicata",
    Molise: "Molise",
    "Blend Red": "Red Blend",
    "Blend White": "White Blend",
    searchPlaceholder: "Search products...",
    results: "Results",
    noResults: "No results found",
    loading: "Loading...",
    showMore: "Show more",
    showLess: "Show less",
    filters: "Filters",
    clearFilters: "Clear filters",
    applyFilters: "Apply filters",
    sortBy: "Sort by",
    relevance: "Relevance",
    priceAsc: "Price: Low to High",
    priceDesc: "Price: High to Low",
    nameAsc: "Name: A-Z",
    nameDesc: "Name: Z-A",
    products: "Products",
    productsCount: "{count} products",
    product: "Product",
    addToCart: "Add to cart",
    viewProduct: "View product",
    outOfStock: "Out of stock",
    inStock: "In stock",
    price: "Price",
    vendor: "Vendor",
    category: "Category",
    collection: "Collection",
    tag: "Tag",
    color: "Color",
    size: "Size",
    material: "Material",
    brand: "Brand",
    type: "Type",
    availability: "Availability",
    rating: "Rating",
    reviews: "Reviews",
    review: "Review",
    compare: "Compare",
    wishlist: "Wishlist",
    quickView: "Quick view",
    newArrival: "New arrivals",
    sale: "Sale",
    bestseller: "Best Selling",
    featured: "Featured",
    recommended: "Recommended",
    trending: "Trending",
    popular: "Popular",
    popularSearches: "Popular searches",
    topRated: "Top rated",
    discount: "Discount",
    free: "Free",
    shipping: "Shipping",
    freeShipping: "Free shipping",
    returns: "Returns",
    freeReturns: "Free returns",
    warranty: "Warranty",
    secure: "Secure",
    payment: "Payment",
    securePayment: "Secure payment",
    checkout: "Checkout",
    cart: "Cart",
    account: "Account",
    login: "Login",
    logout: "Logout",
    register: "Register",
    forgotPassword: "Forgot password?",
    myAccount: "My account",
    myOrders: "My orders",
    myAddresses: "My addresses",
    myWishlist: "My wishlist",
    myReviews: "My reviews",
    settings: "Settings",
    help: "Help",
    contact: "Contact",
    faq: "FAQ",
    about: "About",
    terms: "Terms and conditions",
    privacy: "Privacy",
    cookies: "Cookies",
    countries: "Countries",
    regions: "Regions",
    vendors: "Vendors",
    producers: "Producers",
    appellations: "Appellations",
    grapes: "Grapes",
    onSale: "On Sale",
    bestSeller: "Best Selling",
    mostAwarded: "Most Awarded",
    newIn: "New In",
    activeFilters: "Active filters:",
    clearAll: "Clear all",
    showAllResults: "Show all {count} results",
    resultsFor: 'Results for: "{query}"',
    preorder: "Preorder",
    productsFound: "{count} products found",
    allProducts: "All products",
    BB: "Italian Sommelier Foundation (FIS) guide. This has been one of the most prestigious wine guides in Italy for over 10 years.",
    DE: "Decanter is a wine and lifestyle magazine, published monthly in around 90 countries. It includes industry news, classic guides and advice.",
    RP: "The prestigious international wine guide from Robert Parker, the world's most experienced and trusted wine taster.",
    LM: "One of the most prestigious wine guides in Italy.",
    GR: "Highly respected guide offering the most comprehensive review of Italian wines. Based on blind tastings by over 100 experts.",
    VR: "One of the most prestigious wine guides in Italy.",
    VT: "Italian Sommelier Association (AIS) guide.",
    VO: "Vinous is the online guide from Antonio Galloni, one of the world's leading wine connoisseurs.",
    WS: "Wine Spectator is the most influential wine guide on the internet.",
    SL: "",
    XW: "",
    HC: "The ultimate guide to French wines.",
    JS: "James Suckling is an influential American wine critic (formerly of Wine Spectator). His site JamesSuckling.com specializes in Italian and Bordeaux wines.",
    lowestPrice: "Lowest price",
    lowestPriceText:
      "The lowest price at which the product was on sale during the 30 days before the price reduction.",
  },
  ES: {
    no_products_found: "No se encontraron productos",
    no_products_in_collection: "No hay productos en esta colección actualmente.",
    try_changing_filters: "Intenta cambiar los filtros para ver más productos.",
    clear_filters: "Borrar filtros",
    resetAll: "Restablecer",
    Italy: "Italia",
    France: "Francia",
    Germany: "Alemania",
    Spain: "España",
    "United Kingdom": "Reino Unido",
    Argentina: "Argentina",
    "United States of America": "Estados Unidos",
    "South Africa": "Sudáfrica",
    "Caribbean Sea": "Mar Caribe",
    "New Zealand": "Nueva Zelanda",
    Japan: "Japón",
    Portugal: "Portugal",
    Slovenia: "Eslovenia",
    Chile: "Chile",
    Austria: "Austria",
    Australia: "Australia",
    Hungary: "Hungría",
    Netherlands: "Países Bajos",
    Venezuela: "Venezuela",
    Mexico: "México",
    Uruguay: "Uruguay",
    Armenia: "Armenia",
    "Canary Islands": "Islas Canarias",
    India: "India",
    Sweden: "Suecia",
    Switzerland: "Suiza",
    Greece: "Grecia",
    Ireland: "Irlanda",
    Lebanon: "Líbano",
    Taiwan: "Taiwán",
    Belgium: "Bélgica",
    Brazil: "Brasil",
    China: "China",
    Croatia: "Croacia",
    "Czech Republic": "República Checa",
    Guatemala: "Guatemala",
    Norway: "Noruega",
    Philippines: "Filipinas",
    Poland: "Polonia",
    Russia: "Rusia",
    Israel: "Israel",
    // Regiones
    Tuscany: "Toscana",
    Piedmont: "Piamonte",
    Burgundy: "Borgoña",
    Bordeaux: "Burdeos",
    "Rhone Valley": "Valle del Ródano",
    Mendoza: "Mendoza",
    California: "California",
    Beaujolais: "Beaujolais",
    Rioja: "Rioja",
    Loire: "Loira",
    Jura: "Jura",
    "Uco Valley": "Valle de Uco",
    "Castile and León": "Castilla y León",
    Catalonia: "Cataluña",
    Galicia: "Galicia",
    "Maipo Valley": "Valle del Maipo",
    "Champagne region": "Champaña",
    "Colchagua Valley": "Valle de Colchagua",
    "Barossa Valley": "Valle de Barossa",
    "South Australia": "Australia Meridional",
    "South West": "Suroeste",
    "Valle de Cafayate": "Valle de Cafayate",
    Alsace: "Alsacia",
    "Rapel Valley": "Valle de Rapel",
    Navarre: "Navarra",
    Provence: "Provenza",
    Savoy: "Saboya",
    "Western Australia": "Australia Occidental",
    "Aconcagua Valley": "Valle de Aconcagua",
    "Bekaa Valley": "Valle de la Bekaa",
    "Casablanca Valley": "Valle de Casablanca",
    "Maule Valley": "Valle del Maule",
    "Languedoc-Roussillon": "Languedoc-Rosellón",
    "Trentino Alto Adige": "Trentino-Alto Adigio",
    Veneto: "Véneto",
    "Friuli-Venezia Giulia": "Friuli-Venecia Julia",
    Lombardy: "Lombardía",
    Sicily: "Sicilia",
    "Emilia-Romagna": "Emilia-Romaña",
    Apulia: "Apulia",
    Marche: "Marcas",
    Campania: "Campania",
    Abruzzo: "Abruzos",
    Sardinia: "Cerdeña",
    Umbria: "Umbría",
    Liguria: "Liguria",
    "Aosta Valley": "Valle de Aosta",
    Lazio: "Lacio",
    Calabria: "Calabria",
    Basilicata: "Basilicata",
    Molise: "Molise",
    "Blend Red": "Blend tinto",
    "Blend White": "Blend blanco",
    searchPlaceholder: "Buscar productos...",
    results: "Resultados",
    noResults: "No se encontraron resultados",
    loading: "Cargando...",
    showMore: "Mostrar más",
    showLess: "Mostrar menos",
    filters: "Filtros",
    clearFilters: "Borrar filtros",
    applyFilters: "Aplicar filtros",
    sortBy: "Ordenar por",
    relevance: "Relevancia",
    priceAsc: "Precio: menor a mayor",
    priceDesc: "Precio: mayor a menor",
    nameAsc: "Nombre: A-Z",
    nameDesc: "Nombre: Z-A",
    products: "Productos",
    productsCount: "{count} productos",
    product: "Producto",
    addToCart: "Añadir al carrito",
    viewProduct: "Ver producto",
    outOfStock: "Agotado",
    inStock: "Disponible",
    price: "Precio",
    vendor: "Vendedor",
    category: "Categoría",
    collection: "Colección",
    tag: "Etiqueta",
    color: "Color",
    size: "Tamaño",
    material: "Material",
    brand: "Marca",
    type: "Tipo",
    availability: "Disponibilidad",
    rating: "Puntuación",
    reviews: "Reseñas",
    review: "Reseña",
    compare: "Comparar",
    wishlist: "Lista de deseos",
    quickView: "Vista rápida",
    newArrival: "Novedades",
    sale: "Ofertas",
    bestseller: "Más vendidos",
    featured: "Destacados",
    recommended: "Recomendados",
    trending: "Tendencia",
    popular: "Populares",
    popularSearches: "Búsquedas populares",
    topRated: "Mejor valorados",
    discount: "Descuento",
    free: "Gratis",
    shipping: "Envío",
    freeShipping: "Envío gratis",
    returns: "Devoluciones",
    freeReturns: "Devoluciones gratis",
    warranty: "Garantía",
    secure: "Seguro",
    payment: "Pago",
    securePayment: "Pago seguro",
    checkout: "Tramitar pedido",
    cart: "Carrito",
    account: "Cuenta",
    login: "Iniciar sesión",
    logout: "Cerrar sesión",
    register: "Registrarse",
    forgotPassword: "¿Olvidaste tu contraseña?",
    myAccount: "Mi cuenta",
    myOrders: "Mis pedidos",
    myAddresses: "Mis direcciones",
    myWishlist: "Mi lista de deseos",
    myReviews: "Mis reseñas",
    settings: "Configuración",
    help: "Ayuda",
    contact: "Contacto",
    faq: "Preguntas frecuentes",
    about: "Sobre nosotros",
    terms: "Términos y condiciones",
    privacy: "Privacidad",
    cookies: "Cookies",
    countries: "Países",
    regions: "Regiones",
    vendors: "Vendedores",
    producers: "Productores",
    appellations: "Denominaciones",
    grapes: "Uvas",
    onSale: "En Oferta",
    bestSeller: "Más vendidos",
    mostAwarded: "Más Premiados",
    newIn: "Novedades",
    activeFilters: "Filtros activos:",
    clearAll: "Borrar todo",
    showAllResults: "Mostrar los {count} resultados",
    resultsFor: 'Resultados para: "{query}"',
    preorder: "Preordenar",
    productsFound: "{count} productos encontrados",
    allProducts: "Todos los productos",
    BB: "Guía de la Fundación Italiana de Sommelier (FIS). Una de las guías de vinos más prestigiosas de Italia desde hace más de 10 años.",
    DE: "Decanter es una revista de vinos y estilo de vida publicada en 90 países. Incluye noticias, guías y consejos.",
    RP: "La prestigiosa guía internacional de Robert Parker, el crítico de vinos más experimentado y fiable del mundo.",
    LM: "Una de las guías de vinos más prestigiosas de Italia.",
    GR: "Guía muy respetada con la reseña más completa de vinos italianos, basada en catas a ciegas de más de 100 expertos.",
    VR: "Una de las guías de vinos más prestigiosas de Italia.",
    VT: "Guía de la Asociación Italiana de Sommeliers (AIS).",
    VO: "Vinous es la guía online de Antonio Galloni, uno de los mayores expertos en vino del mundo.",
    WS: "Wine Spectator es la guía de vinos más influyente de Internet.",
    SL: "",
    XW: "",
    HC: "La guía definitiva de los vinos franceses.",
    JS: "James Suckling es un influyente crítico estadounidense (ex Wine Spectator). Su web JamesSuckling.com se especializa en vinos italianos y de Burdeos.",
    lowestPrice: "Precio más bajo",
    lowestPriceText:
      "El precio más bajo de venta en los 30 días previos a la reducción.",
  },
  HK: {
    no_products_found: "找不到產品",
    no_products_in_collection: "目前沒有產品在這個系列中。",
    try_changing_filters: "嘗試更改篩選器以查看更多產品。",
    clear_filters: "清除篩選器",
    resetAll: "重置",
    Italy: "意大利",
    France: "法國",
    Germany: "德國",
    Spain: "西班牙",
    "United Kingdom": "英國",
    Argentina: "阿根廷",
    "United States of America": "美國",
    "South Africa": "南非",
    "Caribbean Sea": "加勒比海",
    "New Zealand": "紐西蘭",
    Japan: "日本",
    Portugal: "葡萄牙",
    Slovenia: "斯洛文尼亞",
    Chile: "智利",
    Austria: "奧地利",
    Australia: "澳洲",
    Hungary: "匈牙利",
    Netherlands: "荷蘭",
    Venezuela: "委內瑞拉",
    Mexico: "墨西哥",
    Uruguay: "烏拉圭",
    Armenia: "亞美尼亞",
    "Canary Islands": "加那利群島",
    India: "印度",
    Sweden: "瑞典",
    Switzerland: "瑞士",
    Greece: "希臘",
    Ireland: "愛爾蘭",
    Lebanon: "黎巴嫩",
    Taiwan: "台灣",
    Belgium: "比利時",
    Brazil: "巴西",
    China: "中國",
    Croatia: "克羅地亞",
    "Czech Republic": "捷克共和國",
    Guatemala: "危地馬拉",
    Norway: "挪威",
    Philippines: "菲律賓",
    Poland: "波蘭",
    Russia: "俄羅斯",
    Israel: "以色列",
    Tuscany: "托斯卡納",
    Piedmont: "皮埃蒙特",
    Burgundy: "勃艮第",
    Bordeaux: "波爾多",
    "Rhone Valley": "隆河谷",
    Mendoza: "門多薩",
    California: "加利福尼亞",
    Beaujolais: "薄若萊",
    Rioja: "里奧哈",
    Loire: "盧瓦爾河谷",
    Jura: "侏羅",
    "Uco Valley": "尤克谷",
    "Castile and León": "卡斯蒂利亞-萊昂",
    Catalonia: "加泰羅尼亞",
    Galicia: "加利西亞",
    "Maipo Valley": "邁波谷",
    "Champagne region": "香檳區",
    "Colchagua Valley": "科爾查瓜谷",
    "Barossa Valley": "巴羅薩谷",
    "South Australia": "南澳",
    "South West": "西南產區",
    "Valle de Cafayate": "卡法亞特谷",
    Alsace: "阿爾薩斯",
    "Rapel Valley": "拉佩爾谷",
    Navarre: "納瓦拉",
    Provence: "普羅旺斯",
    Savoy: "薩瓦",
    "Western Australia": "西澳",
    "Aconcagua Valley": "阿空加瓜谷",
    "Bekaa Valley": "貝卡谷地",
    "Casablanca Valley": "卡薩布蘭卡谷",
    "Maule Valley": "莫萊谷",
    "Languedoc-Roussillon": "朗格多克-魯西永",
    "Trentino Alto Adige": "特倫蒂諾-上阿迪傑",
    Veneto: "威尼托",
    "Friuli-Venezia Giulia": "弗留利-威尼斯朱利亞",
    Lombardy: "倫巴第",
    Sicily: "西西里島",
    "Emilia-Romagna": "艾米利亞-羅馬涅",
    Apulia: "普利亞",
    Marche: "馬爾凱",
    Campania: "坎帕尼亞",
    Abruzzo: "阿布魯佐",
    Sardinia: "撒丁島",
    Umbria: "翁布里亞",
    Liguria: "利古里亞",
    "Aosta Valley": "奧斯塔谷",
    Lazio: "拉齊奧",
    Calabria: "卡拉布里亞",
    Basilicata: "巴西利卡塔",
    Molise: "莫利塞",
    "Blend Red": "混釀紅酒",
    "Blend White": "混釀白酒",
    searchPlaceholder: "搜尋產品...",
    results: "結果",
    noResults: "找不到相關結果",
    loading: "載入中...",
    showMore: "顯示更多",
    showLess: "顯示較少",
    filters: "篩選",
    clearFilters: "清除篩選",
    applyFilters: "套用篩選",
    sortBy: "排序方式",
    relevance: "相關性",
    priceAsc: "價格：由低至高",
    priceDesc: "價格：由高至低",
    nameAsc: "名稱：A-Z",
    nameDesc: "名稱：Z-A",
    products: "產品",
    productsCount: "{count} 款產品",
    product: "產品",
    addToCart: "加入購物車",
    viewProduct: "查看產品",
    outOfStock: "售罄",
    inStock: "現貨",
    price: "價格",
    vendor: "供應商",
    category: "類別",
    collection: "系列",
    tag: "標籤",
    color: "顏色",
    size: "容量",
    material: "材質",
    brand: "品牌",
    type: "類型",
    availability: "庫存狀況",
    rating: "評分",
    reviews: "評論",
    review: "評論",
    compare: "比較",
    wishlist: "願望清單",
    quickView: "快速預覽",
    newArrival: "最新到貨",
    sale: "特價",
    bestseller: "熱賣商品",
    featured: "精選推薦",
    recommended: "為你推薦",
    trending: "熱門趨勢",
    popular: "人氣商品",
    popularSearches: "熱門搜尋",
    topRated: "最高評價",
    discount: "折扣",
    free: "免費",
    shipping: "運費",
    freeShipping: "免運費",
    returns: "退貨",
    freeReturns: "免費退貨",
    warranty: "保養",
    secure: "安全",
    payment: "付款",
    securePayment: "安全付款",
    checkout: "結賬",
    cart: "購物車",
    account: "帳戶",
    login: "登入",
    logout: "登出",
    register: "註冊",
    forgotPassword: "忘記密碼？",
    myAccount: "我的帳戶",
    myOrders: "我的訂單",
    myAddresses: "我的地址",
    myWishlist: "我的願望清單",
    myReviews: "我的評論",
    settings: "設定",
    help: "幫助",
    contact: "聯絡我們",
    faq: "常見問題",
    about: "關於我們",
    terms: "條款及細則",
    privacy: "私隱政策",
    cookies: "Cookie 政策",
    countries: "國家",
    regions: "產區",
    vendors: "酒莊",
    producers: "生產商",
    appellations: "法定產區",
    grapes: "葡萄品種",
    onSale: "特價發售",
    bestSeller: "暢銷榜",
    mostAwarded: "獲獎最多",
    newIn: "新品上市",
    activeFilters: "已選篩選：",
    clearAll: "全部清除",
    showAllResults: "顯示全部 {count} 個結果",
    resultsFor: '搜尋結果："{query}"',
    preorder: "预购",
    productsFound: "找到 {count} 款產品",
    allProducts: "所有產品",
    BB: "意大利侍酒師基金會 (FIS) 指南。十多年來，這一直是意大利最享負盛名的葡萄酒指南之一。",
    DE: "Decanter 是一本葡萄酒與生活時尚雜誌，在約 90 個國家/地區每月出版。雜誌內容包括行業新聞、經典指南以及葡萄酒和烈酒建議。",
    RP: "由著名酒評家 Robert Parker 創立的權威國際葡萄酒指南，他是世界上經驗最豐富、最值得信賴的品酒師。",
    LM: "意大利最享負盛名的葡萄酒指南之一。",
    GR: "備受推崇的指南，提供最全面的意大利葡萄酒評論。擁有悠久傳統，評分基於 100 多位專家的盲品結果。",
    VR: "意大利最享負盛名的葡萄酒指南之一。",
    VT: "意大利侍酒師協會 (AIS) 指南。",
    VO: "Vinous 是由 Antonio Galloni 創立的網上指南，他是世界頂級葡萄酒鑑賞家之一。",
    WS: "Wine Spectator 是互聯網上最具影響力的葡萄酒指南。",
    SL: "",
    XW: "",
    HC: "法國葡萄酒的終極指南。",
    JS: "James Suckling 是一位具影響力的美國酒評家和記者，曾在 Wine Spectator 工作 30 年。他於 2010 年離開雜誌，創立了自己的網站和指南 (JamesSuckling.com)，專注於意大利和波爾多葡萄酒。",
    lowestPrice: "最低價格",
    lowestPriceText: "這是降價前 30 天內的最低銷售價格（包括其他促銷期）。",
  },
};

// Collections translations assignment
const ALGOLIA_TRANSLATIONS_COLLECTION = {
  it: {
    no_products_found: "Nessun prodotto trovato",
    no_products_in_collection: "Non ci sono prodotti in questa collezione attualmente.",
    try_changing_filters: "Prova a modificare i filtri per vedere più prodotti.",
    clear_filters: "Cancella filtri",
    // Filters
    filters_title: "Filtri",
    price: "Prezzo",
    price_from: "Da:",
    price_to: "A:",
    price_min: "Prezzo minimo",
    price_max: "Prezzo massimo",
    price_up_to: "Fino a",
    price_from_to: "Da {min} a {max}",
    price_over: "Oltre",
    apply: "Applica",
    clear_all_filters: "Cancella tutti i filtri",
    active_filters: "Filtri attivi:",
    tipologia: "Tipologia",
    formato: "Formato",
    vitigni: "Vitigni",
    paese: "Paese",
    regioni: "Regioni",
    back_to_countries: "Torna ai Paesi",
    appellation: "Denominazione",
    denominazione: "Denominazione",
    sotto_denominazione: "Sotto-denominazione",
    back_to_appellations: "Torna alle Denominazioni",
    back_to_formats: "Torna ai Formati",
    details: "Dettagli",
    premi: "Premi",
    filosofie: "Stile e Produzione",
    produttore: "Produttore",
    annate: "Annate",
    abbinamenti: "Abbinamenti",
    add_to_cart: "Aggiungi al carrello",
    wishlisted_success: "è stato aggiunto ai favoriti con successo",
    unwishlisted_success: "è stato rimosso dai favoriti con successo",
    product: "prodotto",
    products: "prodotti",
    awarded_by_label: "Premiato {vote} da {guide}",
    award_grapes_label: " grappoli",
    award_glasses_label: " bicchieri",
    award_stars_label: " stelle",
    awards_description: {
      BB: "Guida della Fondazione Italiana Sommelier (FIS) Da oltre 10 anni è una delle guide enologiche più prestigiose d'Italia.",
      DE: "Decanter è una rivista di vino e lifestyle, pubblicata mensilmente in circa 90 paesi. La rivista include notizie di settore, guide classiche e consigli su vino e liquori.",
      RP: "La prestigiosa guida internazionale ai vini del rinomato Robert Parker, il degustatore di vini più esperto e fidato al mondo.",
      LM: "Una delle guide enologiche più prestigiose d'Italia.",
      GR: "Questa guida è molto apprezzata e offre la più completa rassegna dei vini italiani. Vanta una lunga tradizione e si basa su degustazioni alla cieca condotte da oltre 100 esperti.",
      VR: "Una delle guide enologiche più prestigiose d'Italia.",
      VT: "Guida dell'Associazione Italiana Sommelier (AIS)",
      VO: "Vinous è la guida online di Antonio Galloni, uno dei maggiori intenditori di vino al mondo.",
      WS: "Wine Spectator è la guida enologica più influente su Internet.",
      SL: "",
      XW: "",
      HC: "La guida definitiva ai vini francesi.",
      JS: "James Suckling è un influente critico enologico e giornalista americano che ha lavorato per Wine Spectator per 30 anni. Ha lasciato la rivista nel 2010 per fondare il suo sito web e la sua guida (JamesSuckling.com). È specializzato in vini italiani e di Bordeaux.",
    },
    // Active filters
    filter_names: {
      vendor: "Produttore",
      category: "Categoria",
      grapes: "Vitigni",
      region: "Regione",
      awards: "Premi",
      philosophy: "Stile e Produzione",
      dosage: "Dosaggio",
      vintage: "Annata",
      alcohol: "Gradazione Alcolica",
      sub_category: "Metodo",
      price_range: "Prezzo",
      remove_filter: "Rimuovi filtro",
      clear_all: "Cancella",
      no_year: "Senza annata",
      // Search placeholders
      search_awards: "Cerca premi...",
      search_appellations: "Cerca denominazioni...",
      search_subappellations: "Cerca sotto-denominazioni...",
      search_dosage: "Cerca dosaggi...",
      search_grapes: "Cerca vitigni...",
      search_philosophy: "Cerca stile e/o produzione...",
      search_producers: "Cerca produttori...",
      search_pairings: "Cerca abbinamenti...",
      search_vintage: "Cerca annate...",
      search_alcohol: "Cerca gradazione...",
      search_sub_category: "Cerca metodo...",
      search_format: "Cerca formato...",
      search_formatdescription: "Cerca descrizione formato...",
      // No results messages
      no_awards_found: "Nessun premio trovato",
      no_appellations_found: "Nessuna denominazione trovata",
      no_subappellations_found: "Nessuna sotto-denominazione trovata",
      no_dosage_found: "Nessun dosaggio trovato",
      no_grapes_found: "Nessun vitigno trovato",
      no_philosophy_found: "Nessun stile e/o produzione trovata",
      no_producers_found: "Nessun produttore trovato",
      no_pairings_found: "Nessun abbinamento trovato",
      no_vintage_found: "Nessuna annata trovata",
      no_alcohol_found: "Nessuna gradazione trovata",
      no_sub_category_found: "Nessun metodo trovato",
      no_format_found: "Nessun formato trovato",
      no_formatdescription_found: "Nessuna descrizione formato trovata",
      // Load more functionality
      load_more: "Carica altri",
      show_less: "Mostra meno",
      load_more_count: "Carica altri ({count} rimanenti)",
      showing_all: "Mostrando tutti",
    },
    categories: {
      red_wine: "Vino Rosso",
      white_wine: "Vino Bianco",
      rose_wine: "Vino Rosato",
      champagne_sparkling_wine: "Champagne & Spumante",
      champagne: "Champagne",
      sparkling_wine: "Spumante",
      spirits: "Distillati",
      // Spirits specifici
      dessert: "Vini da Dessert",
      gin: "Gin",
      whisky: "Whisky",
      grappa: "Grappa",
      rum: "Rum",
      fortified: "Vini Fortificati",
      liqueurs: "Liquori",
      bitter_liqueur: "Amari",
      vermouth: "Vermouth",
      other_spirits: "Altri Distillati",
      vodka: "Vodka",
      cognac: "Cognac",
      tequila: "Tequila",
      cocktail: "Cocktail",
      cider: "Sidro",
      sake: "Sakè",
      absinthe: "Assenzio",
      brandy: "Brandy",
      calvados: "Calvados",
      // Accessori
      corkscrews: "Cavatappi",
      wine_stoppers: "Tappi per Vino",
      other: "Altro",
      cleaning: "Pulizia",
      sets: "Set",
      bags_containers: "Borse e Contenitori",
      wine_cooling: "Raffreddamento Vino",
    },
    grapes: {
      "Blend Red": "Blend rosso",
      "Blend White": "Blend bianco",
    },
    awards: {
      "Gambero Rosso 3 glasses": "Gambero Rosso 3 bicchieri",
      "Bibenda 4 bunches": "Bibenda 4 grappoli",
      "Bibenda 5 bunches": "Bibenda 5 grappoli",
      "Veronelli 3 red stars": "Veronelli 3 stelle rosse",
      "Vitae AIS 4 vines": "Vitae AIS 4 viti",
      "Vitae AIS 3 vines": "Vitae AIS 3 viti",
      "Gambero Rosso 2 glasses": "Gambero Rosso 2 bicchieri",
      "Veronelli 3 gold stars": "Veronelli 3 stelle oro",
      "Hachette 2 stars": "Hachette 2 stelle",
      "Hachette 3 stars": "Hachette 3 stelle",
    },
    formats: {
      Standard: "Standard",
      Big: "Grande",
      Small: "Piccolo",
    },
    regions: {
      Tuscany: "Toscana",
      Piedmont: "Piemonte",
      Burgundy: "Borgogna",
      Bordeaux: "Bordeaux",
      "Rhone Valley": "Valle del Rodano",
      Mendoza: "Mendoza",
      California: "California",
      Beaujolais: "Beaujolais",
      "South Africa": "Sudafrica",
      Rioja: "Rioja",
      Loire: "Loira",
      Jura: "Jura",
      "Uco Valley": "Uco Valley",
      "Castile and León": "Castiglia e Leon",
      Catalonia: "Catalogna",
      Galicia: "Galizia",
      "Maipo Valley": "Maipo Valley",
      "New Zealand": "Nuova Zelanda",
      "Champagne region": "Champagne area",
      "Colchagua Valley": "Colchagua Valley",
      "Barossa Valley": "Barossa Valley",
      "South Australia": "Australia del Sud",
      "South West": "Sud Ovest",
      "Valle de Cafayate": "Valle de Cafayate",
      Alsace: "Alsazia",
      "Rapel Valley": "Rapel Valley",
      Navarre: "Navarra",
      Provence: "Provenza",
      Savoy: "Savoia",
      "Western Australia": "Australia Occidentale",
      "Aconcagua Valley": "Aconcagua Valley",
      "Bekaa Valley": "Bekaa Valley",
      "Canary Islands": "Isole Canarie",
      "Casablanca Valley": "Casablanca Valley",
      "Maule Valley": "Maule Valley",
      Switzerland: "Svizzera",
      "Languedoc-Roussillon": "Languedoc-Roussillon",
      "Trentino Alto Adige": "Trentino-Alto Adige",
      Veneto: "Veneto",
      "Friuli-Venezia Giulia": "Friuli-Venezia Giulia",
      Lombardy: "Lombardia",
      Sicily: "Sicilia",
      "Emilia-Romagna": "Emilia-Romagna",
      Apulia: "Puglia",
      Marche: "Marche",
      Campania: "Campania",
      Abruzzo: "Abruzzo",
      Sardinia: "Sardegna",
      Umbria: "Umbria",
      Liguria: "Liguria",
      "Aosta Valley": "Valle d'Aosta",
      Lazio: "Lazio",
      Calabria: "Calabria",
      Basilicata: "Basilicata",
      Molise: "Molise",
      Germany: "Germania",
    },
    countries: {
      Italy: "Italia",
      France: "Francia",
      Germany: "Germania",
      Spain: "Spagna",
      "United Kingdom": "Regno Unito",
      Argentina: "Argentina",
      "United States of America": "Stati Uniti",
      "South Africa": "Sudafrica",
      "Carribean Sea": "Mar dei Caraibi",
      "New Zealand": "Nuova Zelanda",
      Japan: "Giappone",
      Portugal: "Portogallo",
      Slovenia: "Slovenia",
      Chile: "Cile",
      Austria: "Austria",
      Australia: "Australia",
      Hungary: "Ungheria",
      Netherlands: "Paesi Bassi",
      Venezuela: "Venezuela",
      Mexico: "Messico",
      Uruguay: "Uruguay",
      Armenia: "Armenia",
      "Canary Islands": "Isole Canarie",
      India: "India",
      Sweden: "Svezia",
      Switzerland: "Svizzera",
      Greece: "Grecia",
      Ireland: "Irlanda",
      Lebanon: "Libano",
      Taiwan: "Taiwan",
      Belgium: "Belgio",
      Brazil: "Brasile",
      China: "Cina",
      Croatia: "Croazia",
      "Czech Republic": "Repubblica Ceca",
      Guatemala: "Guatemala",
      Norway: "Norvegia",
      Philippines: "Filippine",
      Poland: "Polonia",
      Russia: "Russia",
      Israel: "Israele",
    },
    alcohol: {
      "Between 13.6-15.9%": "Tra 13.6-15.9%",
      "Between 12.5-13.5%": "Tra 12.5-13.5%",
      "Less than 12.5%": "Meno del 12.5%",
      "16% or more": "16% o più",
      "Zero alcohol": "Senza alcol",
      "Between 40 - 50%": "Tra 40 - 50%",
      "Between 30 - 40%": "Tra 30 - 40%",
      "50% or more": "50% o più",
      "Between 20 - 30%": "Tra 20 - 30%",
      "Less than 20%": "Meno del 20%",
    },
    philosophies: {
      Artisan: "Artigianali",
      "Certified Biodynamic": "Biodinamici certificati",
      "Certified Organic": "Biologici certificati",
      "Drained barrels or Solera method": "Botti scolme o Solera",
      "Heroic viticulture": "Viticoltura eroica",
      "In amphora": "In anfora",
      "In cement vats": "In vasche di cemento",
      "Independent winemaker": "Vignaiolo indipendente",
      "Indigenous yeasts": "Lieviti indigeni",
      Kosher: "Kosher",
      "Macerated on the skins": "Macerati sulle bucce",
      "Naturally re-fermented": "Rifermentati naturalmente",
      "No added sulphites or minimal sulphites":
        "Senza solfiti aggiunti o minimi",
      "Old vines (+ 40 years)": "Vecchie vigne (+40 anni)",
      "Orange Wine": "Orange Wine",
      "Oxidative style": "Stile ossidativo",
      "Recoltant Manipulant": "Recoltant manipulant",
      "Triple A": "Tripla A",
      Vegan: "Vegani",
      "Zero filtration": "Zero filtrazioni",
    },
    pairings: {
      Cheese: "Formaggi",
      Meat: "Carne",
      Fish: "Pesce",
      Starters: "Antipasti",
      Pasta: "Pasta",
      "Vegetarian dishes": "Piatti vegetariani",
      "Sweets and Desserts": "Dolci e dessert",
      "Spicy food": "Piatti piccanti",
      Pizza: "Pizza",
    },
    sub_categories: {
      "Ancestral Method": "Metodo Ancestrale",
      "Apple cider": "Sidro di mele",
      Aromatised: "Aromatizzato",
      Beer: "Birra",
      "Blanc de Blancs": "Blanc Blanc de Blancs",
      "Blanc de Noirs": "Blanc Blanc de Noirs",
      "Blended Whisky": "Blended Whisky",
      "Bourbon Straight Whisky": "Bourbon Bourbon Straight Whisky",
      "Bourbon Whisky": "Bourbon Whisky",
      Bubbly: "Frizzante",
      "Charmat Method": "Metodo Charmat",
      Classic: "Classico",
      "Classic Method": "Metodo Classico",
      Dessert: "Passito",
      "Dessert from grapes with noble rot":
        "Dessert from grapes with Passito muffato",
      "Foam packaging": "Imballaggi in polistirolo",
      Fortified: "Liquorosi",
      Fruit: "Frutta",
      "Genever or Dutch Gin": "Genever or Genever or Dutch Gin",
      Gin: "Gin",
      "Grain Whisky": "Grain Whisky",
      "Grand Cru": "Grand Cru",
      "Irish Whisky": "Irish Whisky",
      "Japanese Whisky": "Japanese Whisky",
      "Late harvest dessert": "Late Passito vendemmia tardiva",
      "London Dry Gin": "London London Dry Gin",
      "Malt Whisky": "Malt Whisky",
      Millesimé: "Millesimato",
      "Old Tom Gin": "Old Old Tom Gin",
      Others: "Altri",
      "Plymouth Gin": "Plymouth Gin",
      "Premier Cru": "Premier Cru",
      Riserva: "Riserva",
      "Rye Whisky": "Rye Whisky",
      "Sans Année": "Senza Annata",
      "Scotch Whisky": "Scotch Whisky",
      "Single malt Whisky": "Single Single malt Whisky",
      Still: "Fermo",
      Superiore: "Superiore",
      "Tennessee Whiskey": "Tennessee Whiskey",
      Whisky: "Whisky",
      "Whisky Liqueurs": "Whisky Liqueurs",
    },

    // Sorting
    sort_by: "Ordina per:",
    popularity: "Popolarità",
    new_in: "Ultimi arrivi",
    hk_available: "Disponibilità immediata",
    most_awarded: "Più premiati",
    on_sale: "In Offerta",
    best_selling: "Più venduti",
    most_discounted: "Sconto maggiore",
    lowest_price: "Prezzo più basso",
    highest_price: "Prezzo più alto",
    newest_vintage: "Annata più recente",
    oldest_vintage: "Annata più vecchia",
    // Legacy translations (for backward compatibility)
    relevance: "Popolarità",
    price_low_high: "Prezzo più basso",
    price_high_low: "Prezzo più alto",
    name_a_z: "Nome: A-Z",
    name_z_a: "Nome: Z-A",
    newest: "Novità",
    bestselling: "Più venduti",
    vintage_newest: "Annata più recente",
    vintage_oldest: "Annata più vecchia",

    // Results
    loading_products: "Caricamento prodotti...",
    showing_results: "Mostrando {start}-{end} di {total} risultati",
    no_filters_available: "Nessun filtro disponibile",
    lowest_price: "Prezzo più basso",
    lowest_price_strong: "Più basso: ",
    lowest_price_text:
      "È il prezzo più basso a cui il prodotto era in vendita durante i 30 giorni precedenti la riduzione del prezzo, compresi gli altri periodi promozionali",
    list_price_strong: "Prezzo di listino:",
    list_price_text:
      "Indica il prezzo del prodotto prima dell'inizio della promozione",
    remaining_products: "Ultimi {count} prodotti",
    remaining_product: "Ultimo prodotto",
    no_remaining_products: "Non disponibile",
    get_notification: `<span class="default-message"><span class="fw-light">Non disponibile, <span style="font-weight: 700">avvisami!</span></span></span>`,
    express_shipping: `<span class="default-message"><span class="fw-light"><span style="font-weight: 700">Express shipping</span></span></span>`,
    preorder: `<span class="default-message"><span class="fw-light">Preordina</span>`,
    preorder_by: `<span class="default-message"><span class="fw-light">Preordina per il <span style="font-weight: 700">{date}</span></span>`,
    quantity_discount: "Sconto quantità",
  },
  zh: {
    no_products_found: "找不到產品",
    no_products_in_collection: "目前沒有產品在這個系列中。",
    try_changing_filters: "嘗試更改篩選器以查看更多產品。",
    clear_filters: "清除篩選器",
    // Filters
    filters_title: "筛选",
    price: "价格",
    price_from: "从:",
    price_to: "到:",
    price_min: "最低价格",
    price_max: "最高价格",
    price_up_to: "不超过",
    price_from_to: "从 {min} 到 {max}",
    price_over: "超过",
    apply: "应用",
    clear_all_filters: "清除所有筛选条件",
    active_filters: "活动筛选条件:",
    tipologia: "类型",
    formato: "规格",
    vitigni: "葡萄品种",
    paese: "国家",
    regioni: "产区",
    back_to_countries: "返回国家",
    appellation: "产地名称",
    denominazione: "产地名称",
    sotto_denominazione: "子产地名称",
    back_to_appellations: "返回产地名称",
    back_to_formats: "返回规格",
    details: "详情",
    premi: "奖项",
    filosofie: "理念",
    produttore: "生产商",
    annate: "年份",
    abbinamenti: "搭配",
    add_to_cart: "加入购物车",
    wishlisted_success: "已成功添加到愿望清单",
    unwishlisted_success: "已成功从愿望清单中移除",
    product: "商品",
    products: "商品",
    awarded_by_label: "被 {guide} 授予{vote}",
    award_grapes_label: " 葡萄",
    award_glasses_label: " 玻璃杯",
    award_stars_label: " 星星",
    awards_description: {
      BB: "意大利侍酒师基金会 (FIS) 指南 这是意大利十多年来最负盛名的葡萄酒指南之一。",
      DE: "《醇鉴》（Decanter）是一本葡萄酒与生活方式杂志，每月在约 90 个国家/地区出版。该杂志包括行业新闻、经典指南以及葡萄酒和烈酒的建议。",
      RP: "来自著名罗伯特·帕克（Robert Parker）的著名国际葡萄酒指南，他是世界上经验最丰富、最值得信赖的品酒师。",
      LM: "意大利最负盛名的葡萄酒指南之一。",
      GR: "该指南备受推崇，对意大利葡萄酒提供了最全面的评论。它历史悠久，基于 100 多位专家进行的盲品。",
      VR: "意大利最负盛名的葡萄酒指南之一。",
      VT: "意大利侍酒师协会 (AIS) 指南",
      VO: "Vinous 是世界领先的葡萄酒鉴赏家之一安东尼奥·加洛尼 (Antonio Galloni) 的在线指南。",
      WS: "《葡萄酒观察家》（Wine Spectator）是互联网上最有影响力的葡萄酒指南。",
      SL: "",
      XW: "",
      HC: "法国葡萄酒的终极指南。",
      JS: "詹姆斯·萨克林（James Suckling）是一位有影响力的美国葡萄酒评论家和记者，曾在《葡萄酒观察家》（Wine Spectator）工作 30 年。他于 2010 年离开该杂志，创办了自己的网站和指南 (JamesSuckling.com)。他专注于意大利和波尔多葡萄酒。",
    },
    // Active filters
    filter_names: {
      vendor: "生产商",
      category: "类别",
      grapes: "葡萄品种",
      region: "产区",
      awards: "奖项",
      philosophy: "款式和制作",
      dosage: "加糖量",
      vintage: "年份",
      alcohol: "酒精含量",
      sub_category: "方法",
      price_range: "价格",
      remove_filter: "移除筛选条件",
      clear_all: "重置",
      no_year: "无年份",
      // Search placeholders
      search_awards: "搜索奖项...",
      search_appellations: "搜索产地名称...",
      search_subappellations: "搜索子产地名称...",
      search_dosage: "搜索加糖量...",
      search_grapes: "搜索葡萄品种...",
      search_philosophy: "注重风格和制作工艺……",
      search_producers: "搜索生产商...",
      search_pairings: "搜索搭配...",
      search_vintage: "搜索年份...",
      search_alcohol: "搜索酒精含量...",
      search_sub_category: "搜索方法...",
      search_format: "搜索规格...",
      search_formatdescription: "搜索规格描述...",
      // No results messages
      no_awards_found: "未找到奖项",
      no_appellations_found: "未找到产地名称",
      no_subappellations_found: "未找到子产地名称",
      no_dosage_found: "未找到加糖量",
      no_grapes_found: "未找到葡萄品种",
      no_philosophy_found: "未找到任何风格和/或作品",
      no_producers_found: "未找到生产商",
      no_pairings_found: "未找到搭配",
      no_vintage_found: "未找到年份",
      no_alcohol_found: "未找到酒精含量",
      no_sub_category_found: "未找到方法",
      no_format_found: "未找到规格",
      no_formatdescription_found: "未找到规格描述",
      // Load more functionality
      load_more: "加载更多",
      show_less: "显示更少",
      load_more_count: "加载更多 (剩余 {count})",
      showing_all: "显示全部",
    },
    categories: {
      red_wine: "红葡萄酒",
      white_wine: "白葡萄酒",
      rose_wine: "桃红葡萄酒",
      champagne_sparkling_wine: "香槟 & 起泡酒",
      champagne: "香槟",
      sparkling_wine: "起泡酒",
      spirits: "烈酒",
      // Spirits specifici
      dessert: "甜酒",
      gin: "杜松子酒 (Gin)",
      whisky: "威士忌",
      grappa: "格拉巴酒 (Grappa)",
      rum: "朗姆酒 (Rum)",
      fortified: "加强型葡萄酒",
      liqueurs: "利口酒",
      bitter_liqueur: "苦味利口酒",
      vermouth: "味美思 (Vermouth)",
      other_spirits: "其他烈酒",
      vodka: "伏特加 (Vodka)",
      cognac: "干邑 (Cognac)",
      tequila: "龙舌兰酒 (Tequila)",
      cocktail: "鸡尾酒",
      cider: "苹果酒",
      sake: "清酒",
      absinthe: "苦艾酒",
      brandy: "白兰地 (Brandy)",
      calvados: "卡尔瓦多斯 (Calvados)",
      // Accessori
      corkscrews: "开瓶器",
      wine_stoppers: "葡萄酒塞",
      other: "其他",
      cleaning: "清洁",
      sets: "套装",
      bags_containers: "袋子和容器",
      wine_cooling: "葡萄酒冷却",
    },
    grapes: {
      "Blend Red": "混酿红",
      "Blend White": "混酿白",
    },
    awards: {
      "Gambero Rosso 3 glasses": "大红虾 3 杯奖",
      "Bibenda 4 bunches": "Bibenda 4 束奖",
      "Bibenda 5 bunches": "Bibenda 5 束奖",
      "Veronelli 3 red stars": "Veronelli 3 红星奖",
      "Vitae AIS 4 vines": "Vitae AIS 4 葡萄藤奖",
      "Vitae AIS 3 vines": "Vitae AIS 3 葡萄藤奖",
      "Gambero Rosso 2 glasses": "大红虾 2 杯奖",
      "Veronelli 3 gold stars": "Veronelli 3 金星奖",
      "Hachette 2 stars": "哈切特 2 星奖",
      "Hachette 3 stars": "哈切特 3 星奖",
    },
    formats: {
      Standard: "标准",
      Big: "大瓶",
      Small: "小瓶",
    },
    regions: {
      Tuscany: "托斯卡纳",
      Piedmont: "皮埃蒙特",
      Burgundy: "勃艮第",
      Bordeaux: "波尔多",
      "Rhone Valley": "罗纳河谷",
      Mendoza: "门多萨",
      California: "加利福尼亚",
      Beaujolais: "博若莱",
      "South Africa": "南非",
      Rioja: "里奥哈",
      Loire: "卢瓦尔河谷",
      Jura: "汝拉",
      "Uco Valley": "优科谷",
      "Castile and León": "卡斯蒂利亚-莱昂",
      Catalonia: "加泰罗尼亚",
      Galicia: "加利西亚",
      "Maipo Valley": "迈坡谷",
      "New Zealand": "新西兰",
      "Champagne region": "香槟产区",
      "Colchagua Valley": "空加瓜谷",
      "Barossa Valley": "巴罗萨谷",
      "South Australia": "南澳大利亚",
      "South West": "西南部",
      "Valle de Cafayate": "卡法亚特谷",
      Alsace: "阿尔萨斯",
      "Rapel Valley": "拉佩尔谷",
      Navarre: "纳瓦拉",
      Provence: "普罗旺斯",
      Savoy: "萨瓦",
      "Western Australia": "西澳大利亚",
      "Aconcagua Valley": "阿空加瓜谷",
      "Bekaa Valley": "贝卡谷地",
      "Canary Islands": "加那利群岛",
      "Casablanca Valley": "卡萨布兰卡谷",
      "Maule Valley": "马乌莱谷",
      Switzerland: "瑞士",
      "Languedoc-Roussillon": "朗格多克-鲁西荣",
      "Trentino Alto Adige": "特伦蒂诺-上阿迪杰",
      Veneto: "威尼托",
      "Friuli-Venezia Giulia": "弗留利-威尼斯朱利亚",
      Lombardy: "伦巴第",
      Sicily: "西西里岛",
      "Emilia-Romagna": "艾米利亚-罗马涅",
      Apulia: "普利亚",
      Marche: "马尔凯",
      Campania: "坎帕尼亚",
      Abruzzo: "阿布鲁佐",
      Sardinia: "撒丁岛",
      Umbria: "翁布里亚",
      Liguria: "利古里亚",
      "Aosta Valley": "奥斯塔谷",
      Lazio: "拉齐奥",
      Calabria: "卡拉布里亚",
      Basilicata: "巴西利卡塔",
      Molise: "莫利塞",
      Germany: "德国",
    },
    countries: {
      Italy: "意大利",
      France: "法国",
      Germany: "德国",
      Spain: "西班牙",
      "United Kingdom": "英国",
      Argentina: "阿根廷",
      "United States of America": "美国",
      "South Africa": "南非",
      "Carribean Sea": "加勒比海",
      "New Zealand": "新西兰",
      Japan: "日本",
      Portugal: "葡萄牙",
      Slovenia: "斯洛文尼亚",
      Chile: "智利",
      Austria: "奥地利",
      Australia: "澳大利亚",
      Hungary: "匈牙利",
      Netherlands: "荷兰",
      Venezuela: "委内瑞拉",
      Mexico: "墨西哥",
      Uruguay: "乌拉圭",
      Armenia: "亚美尼亚",
      "Canary Islands": "加那利群岛",
      India: "印度",
      Sweden: "瑞典",
      Switzerland: "瑞士",
      Greece: "希腊",
      Ireland: "爱尔兰",
      Lebanon: "黎巴嫩",
      Taiwan: "台湾",
      Belgium: "比利时",
      Brazil: "巴西",
      China: "中国",
      Croatia: "克罗地亚",
      "Czech Republic": "捷克共和国",
      Guatemala: "危地马拉",
      Norway: "挪威",
      Philippines: "菲律宾",
      Poland: "波兰",
      Russia: "俄罗斯",
      Israel: "以色列",
    },
    alcohol: {
      "Between 13.6-15.9%": "13.6-15.9% 之间",
      "Between 12.5-13.5%": "12.5-13.5% 整理",
      "Less than 12.5%": "低于 12.5%",
      "16% or more": "16% 或更多",
      "Zero alcohol": "无酒精",
      "Between 40 - 50%": "40 - 50% 之间",
      "Between 30 - 40%": "30 - 40% 之间",
      "50% or more": "50% 或更多",
      "Between 20 - 30%": "20 - 30% 之间",
      "Less than 20%": "低于 20%",
    },
    philosophies: {
      Artisan: "匠人",
      "Certified Biodynamic": "生物动力学认证",
      "Certified Organic": "有机认证",
      "Drained barrels or Solera method": "排空桶或索莱拉陈酿法",
      "Heroic viticulture": "英雄式葡萄栽培",
      "In amphora": "陶罐陈酿",
      "In cement vats": "水泥罐陈酿",
      "Independent winemaker": "独立酿酒师",
      "Indigenous yeasts": "天然酵母",
      Kosher: "洁食 (Kosher)",
      "Macerated on the skins": "带皮浸渍",
      "Naturally re-fermented": "自然二次发酵",
      "No added sulphites or minimal sulphites": "无添加硫化物或微量硫化物",
      "Old vines (+ 40 years)": "老藤（40 年以上）",
      "Orange Wine": "橙酒",
      "Oxidative style": "氧化风格",
      "Recoltant Manipulant": "独立酒农 (RM)",
      "Triple A": "三 A",
      Vegan: "纯素",
      "Zero filtration": "零过滤",
    },
    pairings: {
      Cheese: "奶酪",
      Meat: "肉类",
      Fish: "鱼类",
      Starters: "开胃菜",
      Pasta: "意大利面",
      "Vegetarian dishes": "素食菜肴",
      "Sweets and Desserts": "糖果和甜点",
      "Spicy food": "辛辣食物",
      Pizza: "披萨",
    },
    sub_categories: {
      "Ancestral Method": "古老法",
      "Apple cider": "苹果酒",
      Aromatised: "加香型",
      Beer: "啤酒",
      "Blanc de Blancs": "白中白",
      "Blanc de Noirs": "黑中白",
      "Blended Whisky": "混合威士忌",
      "Bourbon Straight Whisky": "纯波本威士忌",
      "Bourbon Whisky": "波本威士忌",
      Bubbly: "起泡型",
      "Charmat Method": "查马法",
      Classic: "经典",
      "Classic Method": "经典法",
      Dessert: "甜点酒",
      "Dessert from grapes with noble rot": "贵腐甜酒",
      "Foam packaging": "泡沫包装",
      Fortified: "加强型",
      Fruit: "水果型",
      "Genever or Dutch Gin": "荷式杜松子酒",
      Gin: "杜松子酒 (Gin)",
      "Grain Whisky": "谷物威士忌",
      "Grand Cru": "特级园",
      "Irish Whisky": "爱尔兰威士忌",
      "Japanese Whisky": "日本威士忌",
      "Late harvest dessert": "晚收甜酒",
      "London Dry Gin": "伦敦干杜松子酒",
      "Malt Whisky": "麦芽威士忌",
      Millesimé: "年份香槟",
      "Old Tom Gin": "老汤姆杜松子酒",
      Others: "其他",
      "Plymouth Gin": "普利茅斯杜松子酒",
      "Premier Cru": "一级园",
      Riserva: "珍藏",
      "Rye Whisky": "黑麦威士忌",
      "Sans Année": "无年份",
      "Scotch Whisky": "苏格兰威士忌",
      "Single malt Whisky": "单一麦芽威士忌",
      Still: "静止型",
      Superiore: "优级",
      "Tennessee Whiskey": "田纳西威士忌",
      Whisky: "威士忌",
      "Whisky Liqueurs": "威士忌利口酒",
    },

    // Sorting
    sort_by: "排序方式:",
    popularity: "热门程度",
    new_in: "新品上市",
    hk_available: "立即可用",
    most_awarded: "获奖最多",
    on_sale: "促销中",
    best_selling: "最畅销",
    most_discounted: "折扣最大",
    lowest_price: "价格最低",
    highest_price: "价格最高",
    newest_vintage: "最新年份",
    oldest_vintage: "最旧年份",
    // Legacy translations (for backward compatibility)
    relevance: "热门程度",
    price_low_high: "价格: 从低到高",
    price_high_low: "价格: 从高到低",
    name_a_z: "名称: A-Z",
    name_z_a: "名称: Z-A",
    newest: "最新",
    bestselling: "最畅销",
    vintage_newest: "年份: 最新",
    vintage_oldest: "年份: 最旧",

    // Results
    loading_products: "正在加载商品...",
    showing_results: "显示 {start}-{end} 条，共 {total} 条结果",
    no_filters_available: "无可用筛选条件",
    lowest_price: "最低价格",
    lowest_price_strong: "最低价格: ",
    lowest_price_text: "指产品在降价前 30 天内（包括其他促销期）的最低销售价格",
    list_price_strong: "标价:",
    list_price_text: "指促销开始前产品的价格",
    remaining_products: "最后 {count} 件商品",
    remaining_product: "最后一件商品有货",
    no_remaining_products: "缺货",
    get_notification: `<span class="default-message"><span class="fw-light">缺货，<span style="font-weight: 700">通知我!</span></span></span>`,
    express_shipping: `<span class="default-message"><span class="fw-light"><span style="font-weight: 700">快速配送</span></span></span>`,
    preorder: `<span class="default-message"><span class="fw-light">预订</span>`,
    preorder_by: `<span class="default-message"><span class="fw-light">在 <span style="font-weight: 700">{date}</span> 前预订</span>`,
    quantity_discount: "数量折扣",
  },
  en: {
    no_products_found: "No products found",
    no_products_in_collection: "There are no products in this collection currently.",
    try_changing_filters: "Try changing the filters to see more products.",
    clear_filters: "Clear filters",
    // Filters
    filters_title: "Filters",
    price: "Price",
    price_from: "From:",
    price_to: "To:",
    price_min: "Minimum price",
    price_max: "Maximum price",
    price_up_to: "Up to",
    price_from_to: "From {min} to {max}",
    price_over: "Over",
    apply: "Apply",
    clear_all_filters: "Clear All Filters",
    active_filters: "Active Filters:",
    tipologia: "Type",
    formato: "Format",
    vitigni: "Grape Varieties",
    paese: "Country",
    regioni: "Regions",
    back_to_countries: "Back to Countries",
    appellation: "Appellation",
    denominazione: "Appellation",
    sotto_denominazione: "Sub-Appellation",
    back_to_appellations: "Back to Appellations",
    back_to_formats: "Back to Formats",
    details: "Details",
    premi: "Awards",
    filosofie: "Style and production",
    produttore: "Producer",
    annate: "Vintage",
    abbinamenti: "Pairings",
    add_to_cart: "Add to Cart",
    wishlisted_success: "has been added to wishlist successfully",
    unwishlisted_success: "has been removed from wishlist successfully",
    product: "product",
    products: "products",
    awarded_by_label: "Awarded {vote} by {guide}",
    award_grapes_label: " grapes",
    award_glasses_label: " glasses",
    award_stars_label: " stars",
    awards_description: {
      BB: "Italian Sommelier Foundation (FIS) guide This has been one of the most prestigious wine guides in Italy for over 10 years.",
      DE: "Decanter is a wine and lifestyle magazine, published monthly in around 90 countries. The magazine includes industry news, classic guides and advice on wine and spirits.",
      RP: "The prestigious international wine guide from the renowned Robert Parker, the world's most experienced and trusted wine taster.",
      LM: "One of the most prestigious wine guides in Italy.",
      GR: "This guide is highly respected and offers the most comprehensive review of Italian wines. It has a long tradition and is based on blind tastings carried out by over 100 experts.",
      VR: "One of the most prestigious wine guides in Italy.",
      VT: "Italian Sommelier Association (AIS) guide",
      VO: "Vinous is the online guide from Antonio Galloni, one of the world's leading wine connoisseurs.",
      WS: "Wine spectator is the most influential wine guide on the internet.",
      SL: "",
      XW: "",
      HC: "The ultimate guide to French wines.",
      JS: "James Suckling is an influential American wine critic and journalist who worked at Wine Spectator for 30 years. He left the magazine in 2010 to start his own website and guidebook (JamesSuckling.com). He specialises in Italian and Bordeaux wines.",
    },
    // Active filters
    filter_names: {
      vendor: "Producer",
      category: "Category",
      grapes: "Grape Varieties",
      region: "Region",
      awards: "Awards",
      philosophy: "Style and production",
      dosage: "Dosage",
      vintage: "Vintage",
      alcohol: "Alcohol Content",
      sub_category: "Method",
      price_range: "Price",
      remove_filter: "Remove filter",
      clear_all: "Reset",
      no_year: "No vintage",
      // Search placeholders
      search_awards: "Search awards...",
      search_appellations: "Search appellations...",
      search_subappellations: "Search sub-appellations...",
      search_dosage: "Search dosage...",
      search_grapes: "Search grapes...",
      search_philosophy: "Search style and/or productions...",
      search_producers: "Search producers...",
      search_pairings: "Search pairings...",
      search_vintage: "Search vintage...",
      search_alcohol: "Search alcohol...",
      search_sub_category: "Search method...",
      search_format: "Search format...",
      search_formatdescription: "Search format description...",
      // No results messages
      no_awards_found: "No awards found",
      no_appellations_found: "No appellations found",
      no_subappellations_found: "No sub-appellations found",
      no_dosage_found: "No dosage found",
      no_grapes_found: "No grapes found",
      no_philosophy_found: "No style and/or production found",
      no_producers_found: "No producers found",
      no_pairings_found: "No pairings found",
      no_vintage_found: "No vintage found",
      no_alcohol_found: "No alcohol content found",
      no_sub_category_found: "No method found",
      no_format_found: "No format found",
      no_formatdescription_found: "No format description found",
      // Load more functionality
      load_more: "Load more",
      show_less: "Show less",
      load_more_count: "Load more ({count} remaining)",
      showing_all: "Showing all",
    },
    categories: {
      red_wine: "Red Wine",
      white_wine: "White Wine",
      rose_wine: "Rosé Wine",
      champagne_sparkling_wine: "Champagne & Sparkling Wine",
      champagne: "Champagne",
      sparkling_wine: "Sparkling Wine",
      spirits: "Spirits",
      // Spirits specifici
      dessert: "Dessert Wines",
      gin: "Gin",
      whisky: "Whisky",
      grappa: "Grappa",
      rum: "Rum",
      fortified: "Fortified Wines",
      liqueurs: "Liqueurs",
      bitter_liqueur: "Bitter Liqueurs",
      vermouth: "Vermouth",
      other_spirits: "Other Spirits",
      vodka: "Vodka",
      cognac: "Cognac",
      tequila: "Tequila",
      cocktail: "Cocktail",
      cider: "Cider",
      sake: "Sake",
      absinthe: "Absinthe",
      brandy: "Brandy",
      calvados: "Calvados",
      // Accessori
      corkscrews: "Corkscrews",
      wine_stoppers: "Wine Stoppers",
      other: "Other",
      cleaning: "Cleaning",
      sets: "Sets",
      bags_containers: "Bags & Containers",
      wine_cooling: "Wine Cooling",
    },
    grapes: {
      "Blend Red": "Blend red",
      "Blend White": "Blend white",
    },
    awards: {
      "Gambero Rosso 3 glasses": "Gambero Rosso 3 glasses",
      "Bibenda 4 bunches": "Bibenda 4 bunches",
      "Bibenda 5 bunches": "Bibenda 5 bunches",
      "Veronelli 3 red stars": "Veronelli 3 red stars",
      "Vitae AIS 4 vines": "Vitae AIS 4 vines",
      "Vitae AIS 3 vines": "Vitae AIS 3 vines",
      "Gambero Rosso 2 glasses": "Gambero Rosso 2 glasses",
      "Veronelli 3 gold stars": "Veronelli 3 gold stars",
      "Hachette 2 stars": "Hachette 2 stars",
      "Hachette 3 stars": "Hachette 3 stars",
    },
    formats: {
      Standard: "Standard",
      Big: "Big",
      Small: "Small",
    },
    regions: {
      Tuscany: "Tuscany",
      Piedmont: "Piedmont",
      Burgundy: "Burgundy",
      Bordeaux: "Bordeaux",
      "Rhone Valley": "Rhone Valley",
      Mendoza: "Mendoza",
      California: "California",
      Beaujolais: "Beaujolais",
      "South Africa": "South Africa",
      Rioja: "Rioja",
      Loire: "Loire",
      Jura: "Jura",
      "Uco Valley": "Uco Valley",
      "Castile and León": "Castile and León",
      Catalonia: "Catalonia",
      Galicia: "Galicia",
      "Maipo Valley": "Maipo Valley",
      "New Zealand": "New Zealand",
      "Champagne region": "Champagne region",
      "Colchagua Valley": "Colchagua Valley",
      "Barossa Valley": "Barossa Valley",
      "South Australia": "South Australia",
      "South West": "South West",
      "Valle de Cafayate": "Valle de Cafayate",
      Alsace: "Alsace",
      "Rapel Valley": "Rapel Valley",
      Navarre: "Navarre",
      Provence: "Provence",
      Savoy: "Savoy",
      "Western Australia": "Western Australia",
      "Aconcagua Valley": "Aconcagua Valley",
      "Bekaa Valley": "Bekaa Valley",
      "Canary Islands": "Canary Islands",
      "Casablanca Valley": "Casablanca Valley",
      "Maule Valley": "Maule Valley",
      Switzerland: "Switzerland",
      "Languedoc-Roussillon": "Languedoc-Roussillon",
      "Trentino Alto Adige": "Trentino Alto Adige",
      Veneto: "Veneto",
      "Friuli-Venezia Giulia": "Friuli-Venezia Giulia",
      Lombardy: "Lombardy",
      Sicily: "Sicily",
      "Emilia-Romagna": "Emilia-Romagna",
      Apulia: "Apulia",
      Marche: "Marche",
      Campania: "Campania",
      Abruzzo: "Abruzzo",
      Sardinia: "Sardinia",
      Umbria: "Umbria",
      Liguria: "Liguria",
      "Aosta Valley": "Aosta Valley",
      Lazio: "Lazio",
      Calabria: "Calabria",
      Basilicata: "Basilicata",
      Molise: "Molise",
      Germany: "Germany",
    },
    countries: {
      Italy: "Italy",
      France: "France",
      Germany: "Germany",
      Spain: "Spain",
      "United Kingdom": "United Kingdom",
      Argentina: "Argentina",
      "United States of America": "United States",
      "South Africa": "South Africa",
      "Carribean Sea": "Caribbean Sea",
      "New Zealand": "New Zealand",
      Japan: "Japan",
      Portugal: "Portugal",
      Slovenia: "Slovenia",
      Chile: "Chile",
      Austria: "Austria",
      Australia: "Australia",
      Hungary: "Hungary",
      Netherlands: "Netherlands",
      Venezuela: "Venezuela",
      Mexico: "Mexico",
      Uruguay: "Uruguay",
      Armenia: "Armenia",
      "Canary Islands": "Canary Islands",
      India: "India",
      Sweden: "Sweden",
      Switzerland: "Switzerland",
      Greece: "Greece",
      Ireland: "Ireland",
      Lebanon: "Lebanon",
      Taiwan: "Taiwan",
      Belgium: "Belgium",
      Brazil: "Brazil",
      China: "China",
      Croatia: "Croatia",
      "Czech Republic": "Czech Republic",
      Guatemala: "Guatemala",
      Norway: "Norway",
      Philippines: "Philippines",
      Poland: "Poland",
      Russia: "Russia",
      Israel: "Israel",
    },
    alcohol: {
      "Between 13.6-15.9%": "Between 13.6-15.9%",
      "Between 12.5-13.5%": "Between 12.5-13.5%",
      "Less than 12.5%": "Less than 12.5%",
      "16% or more": "16% or more",
      "Zero alcohol": "Zero alcohol",
    },
    philosophies: {
      Artisan: "Artisan",
      "Certified Biodynamic": "Certified Biodynamic",
      "Certified Organic": "Certified Organic",
      "Drained barrels or Solera method": "Drained barrels or Solera method",
      "Heroic viticulture": "Heroic viticulture",
      "In amphora": "In amphora",
      "In cement vats": "In cement vats",
      "Independent winemaker": "Independent winemaker",
      "Indigenous yeasts": "Indigenous yeasts",
      Kosher: "Kosher",
      "Macerated on the skins": "Macerated on the skins",
      "Naturally re-fermented": "Naturally re-fermented",
      "No added sulphites or minimal sulphites":
        "No added sulphites or minimal sulphites",
      "Old vines (+ 40 years)": "Old vines (+ 40 years)",
      "Orange Wine": "Orange Wine",
      "Oxidative style": "Oxidative style",
      "Recoltant Manipulant": "Recoltant Manipulant",
      "Triple A": "Triple A",
      Vegan: "Vegan",
      "Zero filtration": "Zero filtration",
    },
    pairings: {
      Cheese: "Cheese",
      Meat: "Meat",
      Fish: "Fish",
      Starters: "Starters",
      Pasta: "Pasta",
      "Vegetarian dishes": "Vegetarian dishes",
      "Sweets and Desserts": "Sweets and Desserts",
      "Spicy food": "Spicy food",
      Pizza: "Pizza",
    },
    sub_categories: {
      "Ancestral Method": "Ancestral Method",
      "Apple cider": "Apple cider",
      Aromatised: "Aromatised",
      Beer: "Beer",
      "Blanc de Blancs": "Blanc de Blancs",
      "Blanc de Noirs": "Blanc de Noirs",
      "Blended Whisky": "Blended Whisky",
      "Bourbon Straight Whisky": "Bourbon Straight Whisky",
      "Bourbon Whisky": "Bourbon Whisky",
      Bubbly: "Bubbly",
      "Charmat Method": "Charmat Method",
      Classic: "Classic",
      "Classic Method": "Classic Method",
      Dessert: "Dessert",
      "Dessert from grapes with noble rot":
        "Dessert from grapes with noble rot",
      "Foam packaging": "Foam packaging",
      Fortified: "Fortified",
      Fruit: "Fruit",
      "Genever or Dutch Gin": "Genever or Dutch Gin",
      Gin: "Gin",
      "Grain Whisky": "Grain Whisky",
      "Grand Cru": "Grand Cru",
      "Irish Whisky": "Irish Whisky",
      "Japanese Whisky": "Japanese Whisky",
      "Late harvest dessert": "Late harvest dessert",
      "London Dry Gin": "London Dry Gin",
      "Malt Whisky": "Malt Whisky",
      Millesimé: "Millesimé",
      "Old Tom Gin": "Old Tom Gin",
      Others: "Others",
      "Plymouth Gin": "Plymouth Gin",
      "Premier Cru": "Premier Cru",
      Riserva: "Riserva",
      "Rye Whisky": "Rye Whisky",
      "Sans Année": "Sans Année",
      "Scotch Whisky": "Scotch Whisky",
      "Single malt Whisky": "Single malt Whisky",
      Still: "Still",
      Superiore: "Superiore",
      "Tennessee Whiskey": "Tennessee Whiskey",
      Whisky: "Whisky",
      "Whisky Liqueurs": "Whisky Liqueurs",
    },

    // Sorting
    sort_by: "Sort by:",
    popularity: "Popularity",
    new_in: "New In",
    hk_available: "Immediate availability",
    most_awarded: "Most Awarded",
    on_sale: "On Sale",
    best_selling: "Best Selling",
    most_discounted: "Most Discounted",
    lowest_price: "Lowest Price",
    highest_price: "Highest Price",
    newest_vintage: "Newest Vintage",
    oldest_vintage: "Oldest Vintage",
    // Legacy translations (for backward compatibility)
    relevance: "Popularity",
    price_low_high: "Price: Low to High",
    price_high_low: "Price: High to Low",
    name_a_z: "Name: A-Z",
    name_z_a: "Name: Z-A",
    newest: "Newest",
    bestselling: "Best Selling",
    vintage_newest: "Vintage: Newest",
    vintage_oldest: "Vintage: Oldest",

    // Results
    loading_products: "Loading products...",
    showing_results: "Showing {start}-{end} of {total} results",
    no_filters_available: "No filters available",
    lowest_price: "Lowest price",
    lowest_price_strong: "Lowest: ",
    lowest_price_text:
      "Is the lowest price at which the product was on sale during the 30 days before the price reduction, including other promotional periods",
    list_price_strong: "List price:",
    list_price_text:
      "Indicates the price of the product before the start of the promotion",
    remaining_products: "Last {count} products",
    remaining_product: "Last product",
    no_remaining_products: "Not available",
    get_notification: `<span class="default-message"><span class="fw-light">Not available, <span style="font-weight: 700">notify me!</span></span></span>`,
    express_shipping: `<span class="default-message"><span class="fw-light"><span style="font-weight: 700">Express shipping</span></span></span>`,
    preorder: `<span class="default-message"><span class="fw-light">Preorder</span>`,
    preorder_by: `<span class="default-message"><span class="fw-light">Preorder by <span style="font-weight: 700">{date}</span></span>`,
    quantity_discount: "Quantity discount",
  },
  fr: {
    no_products_found: "Aucun produit trouvé",
    no_products_in_collection: "Il n'y a pas de produits dans cette collection actuellement.",
    try_changing_filters: "Essayez de modifier les filtres pour voir plus de produits.",
    clear_filters: "Effacer les filtres",
    // Filters
    filters_title: "Filtres",
    price: "Prix",
    price_up_to: "Jusqu'à",
    price_from_to: "De {min} à {max}",
    price_over: "Plus de",
    apply: "Appliquer",
    clear_all_filters: "Effacer tous les filtres",
    active_filters: "Filtres actifs:",
    tipologia: "Typologie",
    formato: "Format",
    vitigni: "Cépages",
    paese: "Pays",
    regioni: "Régions",
    back_to_countries: "Retour aux Pays",
    appellation: "Appellation",
    denominazione: "Appellation",
    sotto_denominazione: "Sous-Appellation",
    back_to_appellations: "Retour aux Appellations",
    back_to_formats: "Retour aux Formats",
    details: "Détails",
    premi: "Récompenses",
    filosofie: "Style et réalisation",
    produttore: "Producteur",
    annate: "Millésime",
    abbinamenti: "Accords",
    add_to_cart: "Ajouter au panier",
    wishlisted_success: "a été ajouté à la liste de souhaits avec succès",
    unwishlisted_success: "a été retiré de la liste de souhaits avec succès",
    product: "produit",
    products: "produits",
    awarded_by_label: "Récompensé {vote} par {guide}",
    award_grapes_label: " raisins",
    award_glasses_label: " lunettes",
    award_stars_label: " étoiles",
    awards_description: {
      BB: "Guide de la Fondation Italienne du Sommelier (FIS) C'est l'un des guides de vins les plus prestigieux d'Italie depuis plus de 10 ans.",
      DE: "Decanter est un magazine consacré au vin et à l'art de vivre, publié mensuellement dans près de 90 pays. Il propose des actualités du secteur, des guides classiques et des conseils sur les vins et spiritueux.",
      RP: "Le prestigieux guide international des vins du célèbre Robert Parker, le dégustateur de vins le plus expérimenté et le plus fiable au monde.",
      LM: "L'un des guides de vins les plus prestigieux d'Italie.",
      GR: "Ce guide, très réputé, propose la revue la plus complète des vins italiens. Fort d'une longue tradition, il s'appuie sur des dégustations à l'aveugle réalisées par plus de 100 experts.",
      VR: "L'un des guides de vins les plus prestigieux d'Italie.",
      VT: "Guide de l'Association italienne des sommeliers (AIS)",
      VO: "Vinous est le guide en ligne d'Antonio Galloni, l'un des plus grands connaisseurs de vin au monde.",
      WS: "Wine Spectator est le guide des vins le plus influent sur Internet.",
      SL: "",
      XW: "",
      HC: "Le guide ultime des vins français.",
      JS: "James Suckling est un critique et journaliste œnologique américain influent qui a travaillé pour Wine Spectator pendant 30 ans. Il a quitté le magazine en 2010 pour créer son propre site web et guide (JamesSuckling.com). Il est spécialisé dans les vins italiens et bordelais.",
    },
    // Active filters
    filter_names: {
      vendor: "Producteur",
      category: "Catégorie",
      grapes: "Cépages",
      region: "Région",
      awards: "Prix",
      philosophy: "Style et réalisation",
      dosage: "Dosage",
      vintage: "Millésime",
      alcohol: "Teneur en Alcool",
      sub_category: "Méthode",
      price_range: "Prix",
      remove_filter: "Supprimer le filtre",
      clear_all: "Effacer tout",
      no_year: "Sans millésime",
      // Search placeholders
      search_awards: "Rechercher prix...",
      search_appellations: "Rechercher appellations...",
      search_subappellations: "Rechercher sous-appellations...",
      search_dosage: "Rechercher dosage...",
      search_grapes: "Rechercher cépages...",
      search_philosophy: "Rechercher style et réalisation...",
      search_producers: "Rechercher producteurs...",
      search_pairings: "Rechercher accords...",
      search_vintage: "Rechercher millésime...",
      search_alcohol: "Rechercher alcool...",
      search_sub_category: "Rechercher méthode...",
      search_format: "Rechercher format...",
      search_formatdescription: "Rechercher description format...",
      // No results messages
      no_awards_found: "Aucun prix trouvé",
      no_appellations_found: "Aucune appellation trouvée",
      no_subappellations_found: "Aucune sous-appellation trouvée",
      no_dosage_found: "Aucun dosage trouvé",
      no_grapes_found: "Aucun cépage trouvé",
      no_philosophy_found: "Aucune style et réalisation trouvée",
      no_producers_found: "Aucun producteur trouvé",
      no_pairings_found: "Aucun accord trouvé",
      no_vintage_found: "Aucun millésime trouvé",
      no_alcohol_found: "Aucune teneur en alcool trouvée",
      no_sub_category_found: "Aucune méthode trouvée",
      no_format_found: "Aucun format trouvé",
      no_formatdescription_found: "Aucune description format trouvée",
      // Load more functionality
      load_more: "Charger plus",
      show_less: "Afficher moins",
      load_more_count: "Charger plus ({count} restants)",
      showing_all: "Affichage de tous",
    },
    categories: {
      red_wine: "Vin Rouge",
      white_wine: "Vin Blanc",
      rose_wine: "Vin Rosé",
      champagne_sparkling_wine: "Champagne & Mousseux",
      champagne: "Champagne",
      sparkling_wine: "Mousseux",
      spirits: "Spiritueux",
      // Spirits specifici
      dessert: "Vins de Dessert",
      gin: "Gin",
      whisky: "Whisky",
      grappa: "Grappa",
      rum: "Rhum",
      fortified: "Vins Fortifiés",
      liqueurs: "Liqueurs",
      bitter_liqueur: "Liqueurs Amères",
      vermouth: "Vermouth",
      other_spirits: "Autres Spiritueux",
      vodka: "Vodka",
      cognac: "Cognac",
      tequila: "Tequila",
      cocktail: "Cocktail",
      cider: "Cidre",
      sake: "Saké",
      absinthe: "Absinthe",
      brandy: "Brandy",
      calvados: "Calvados",
      // Accessori
      corkscrews: "Tire-bouchons",
      wine_stoppers: "Bouchons à Vin",
      other: "Autre",
      cleaning: "Nettoyage",
      sets: "Ensembles",
      bags_containers: "Sacs et Contenants",
      wine_cooling: "Refroidissement du Vin",
    },
    grapes: {
      "Blend Red": "Blend rouge",
      "Blend White": "Blend blanc",
    },
    awards: {
      "Gambero Rosso 3 glasses": "Gambero Rosso 3 verres",
      "Bibenda 4 bunches": "Bibenda 4 grappes",
      "Bibenda 5 bunches": "Bibenda 5 grappes",
      "Veronelli 3 red stars": "Veronelli 3 étoiles rouges",
      "Vitae AIS 4 vines": "Vitae AIS 4 vignes",
      "Vitae AIS 3 vines": "Vitae AIS 3 vignes",
      "Gambero Rosso 2 glasses": "Gambero Rosso 2 verres",
      "Veronelli 3 gold stars": "Veronelli 3 étoiles dorées",
      "Hachette 2 stars": "Hachette 2 étoiles",
      "Hachette 3 stars": "Hachette 3 étoiles",
    },
    formats: {
      Standard: "Standard",
      Big: "Grande",
      Small: "Petit",
    },
    regions: {
      Tuscany: "Toscane",
      Piedmont: "Piémont",
      Burgundy: "Bourgogne",
      Bordeaux: "Bordeaux",
      "Rhone Valley": "Vallée du Rhône",
      Mendoza: "Mendoza",
      California: "Californie",
      Beaujolais: "Beaujolais",
      "South Africa": "Afrique du Sud",
      Rioja: "Rioja",
      Loire: "Loire",
      Jura: "Jura",
      "Uco Valley": "Uco Valley",
      "Castile and León": "Castille et Léon",
      Catalonia: "Catalogne",
      Galicia: "Galice",
      "Maipo Valley": "Maipo Valley",
      "New Zealand": "Nouvelle-Zélande",
      "Champagne region": "Région de Champagne",
      "Colchagua Valley": "Colchagua Valley",
      "Barossa Valley": "Barossa Valley",
      "South Australia": "Australie-Méridionale",
      "South West": "Sud-Ouest",
      "Valle de Cafayate": "Valle de Cafayate",
      Alsace: "Alsace",
      "Rapel Valley": "Rapel Valley",
      Navarre: "Navarre",
      Provence: "Provence",
      Savoy: "Savoie",
      "Western Australia": "Australie-Occidentale",
      "Aconcagua Valley": "Aconcagua Valley",
      "Bekaa Valley": "Bekaa Valley",
      "Canary Islands": "Les Îles Canaries",
      "Casablanca Valley": "Casablanca Valley",
      "Maule Valley": "Maule Valley",
      Switzerland: "Suisse",
      "Languedoc-Roussillon": "Languedoc-Roussillon",
      "Trentino Alto Adige": "Trentin-Haut-Adige",
      Veneto: "Vénétie",
      "Friuli-Venezia Giulia": "Frioul-Vénétie Julienne",
      Lombardy: "Lombardie",
      Sicily: "Sicile",
      "Emilia-Romagna": "Émilie-Romagne",
      Apulia: "Pouilles",
      Marche: "Marches",
      Campania: "Campanie",
      Abruzzo: "Abruzzes",
      Sardinia: "Sardaigne",
      Umbria: "Ombrie",
      Liguria: "Ligurie",
      "Aosta Valley": "Vallée d'Aoste",
      Lazio: "Latium",
      Calabria: "Calabre",
      Basilicata: "Basilicate",
      Molise: "Molise",
      Germany: "Allemagne",
    },
    countries: {
      Italy: "Italie",
      France: "France",
      Germany: "Allemagne",
      Spain: "Espagne",
      "United Kingdom": "Royaume-Uni",
      Argentina: "Argentine",
      "United States of America": "États-Unis",
      "South Africa": "Afrique du Sud",
      "Carribean Sea": "Mer des Caraïbes",
      "New Zealand": "Nouvelle-Zélande",
      Japan: "Japon",
      Portugal: "Portugal",
      Slovenia: "Slovénie",
      Chile: "Chili",
      Austria: "Autriche",
      Australia: "Australie",
      Hungary: "Hongrie",
      Netherlands: "Pays-Bas",
      Venezuela: "Venezuela",
      Mexico: "Mexique",
      Uruguay: "Uruguay",
      Armenia: "Arménie",
      "Canary Islands": "Les Îles Canaries",
      India: "Inde",
      Sweden: "Suède",
      Switzerland: "Suisse",
      Greece: "Grèce",
      Ireland: "Irlande",
      Lebanon: "Liban",
      Taiwan: "Taïwan",
      Belgium: "Belgique",
      Brazil: "Brésil",
      China: "Chine",
      Croatia: "Croatie",
      "Czech Republic": "République Tchèque",
      Guatemala: "Guatemala",
      Norway: "Norvège",
      Philippines: "Philippines",
      Poland: "Pologne",
      Russia: "Russie",
      Israel: "Israël",
    },
    alcohol: {
      "Between 13.6-15.9%": "Entre 13.6-15.9%",
      "Between 12.5-13.5%": "Entre 12.5-13.5%",
      "Less than 12.5%": "Moins de 12.5%",
      "16% or more": "16 % ou plus",
      "Zero alcohol": "Sans alcool",
      "Between 40 - 50%": "Entre 40 - 50%",
      "Between 30 - 40%": "Entre 30 - 40%",
      "50% or more": "50 % ou plus",
      "Between 20 - 30%": "Entre 20 - 30%",
      "Less than 20%": "Moins de 20%",
    },
    philosophies: {
      Artisan: "Artisanaux",
      "Certified Biodynamic": "Certifiés biodynamiques",
      "Certified Organic": "Certifiés biologiques",
      "Drained barrels or Solera method": "Fûts scolme ou Solera",
      "Heroic viticulture": "Viticulture héroïque",
      "In amphora": "En amphore",
      "In cement vats": "Dans des cuves en béton",
      "Independent winemaker": "Vigneron indépendant",
      "Indigenous yeasts": "Levures indigènes",
      Kosher: "Kasher",
      "Macerated on the skins": "Macérés avec la peau",
      "Naturally re-fermented": "Fermentés naturellement",
      "No added sulphites or minimal sulphites":
        "Pas ou peu de sulfites ajoutés",
      "Old vines (+ 40 years)": "Vieilles vignes (+ 40 ans)",
      "Orange Wine": "Vin orange",
      "Oxidative style": "Style oxydatif",
      "Recoltant Manipulant": "Récoltant Manipulant",
      "Triple A": "Triple A",
      Vegan: "Vegans",
      "Zero filtration": "Zéro filtration",
    },
    pairings: {
      Cheese: "Fromage",
      Meat: "Viande",
      Fish: "Poisson",
      Starters: "Entrées",
      Pasta: "Pâtes",
      "Vegetarian dishes": "Plats végétariens",
      "Sweets and Desserts": "Confiseries et desserts",
      "Spicy food": "Plats épicés",
      Pizza: "Pizza",
    },
    sub_categories: {
      "Ancestral Method": "Méthode Ancestrale",
      "Apple cider": "Apple cider",
      Aromatised: "Aromatisé",
      Beer: "Beer",
      "Blanc de Blancs": "Blanc Blanc de Blancs",
      "Blanc de Noirs": "Blanc Blanc de Noirs",
      "Blended Whisky": "Blended Whisky",
      "Bourbon Straight Whisky": "Bourbon Bourbon Straight Whisky",
      "Bourbon Whisky": "Bourbon Whisky",
      Bubbly: "Pétillant",
      "Charmat Method": "Méthode Charmat",
      Classic: "Classique",
      "Classic Method": "Méthode Classique",
      Dessert: "Doux",
      "Dessert from grapes with noble rot":
        "Dessert from grapes with Doux issu de raisins à pourriture noble",
      "Foam packaging": "Emballages en polystyrène",
      Fortified: "Liquoreux",
      Fruit: "Fruit",
      "Genever or Dutch Gin": "Genever or Genever or Dutch Gin",
      Gin: "Gin",
      "Grain Whisky": "Grain Whisky",
      "Grand Cru": "Grand Cru",
      "Irish Whisky": "Irish Whisky",
      "Japanese Whisky": "Japanese Whisky",
      "Late harvest dessert": "Late Doux vendanges tardives",
      "London Dry Gin": "London London Dry Gin",
      "Malt Whisky": "Malt Whisky",
      Millesimé: "Millésime",
      "Old Tom Gin": "Old Old Tom Gin",
      Others: "Others",
      "Plymouth Gin": "Plymouth Gin",
      "Premier Cru": "Premier Cru",
      Riserva: "Riserva",
      "Rye Whisky": "Rye Whisky",
      "Sans Année": "Sans Année",
      "Scotch Whisky": "Scotch Whisky",
      "Single malt Whisky": "Single Single malt Whisky",
      Still: "Tranquille",
      Superiore: "Supérieur",
      "Tennessee Whiskey": "Tennessee Whiskey",
      Whisky: "Whisky",
      "Whisky Liqueurs": "Whisky Liqueurs",
    },

    // Sorting
    sort_by: "Trier par:",
    popularity: "Popularité",
    new_in: "Nouveautés",
    hk_available: "Disponibilité immédiate",
    most_awarded: "Plus Primés",
    on_sale: "En Solde",
    best_selling: "Meilleures ventes",
    most_discounted: "Plus Réduits",
    lowest_price: "Prix Plus Bas",
    highest_price: "Prix Plus Élevé",
    newest_vintage: "Millésime Plus Récent",
    oldest_vintage: "Millésime Plus Ancien",
    // Legacy translations (for backward compatibility)
    relevance: "Popularité",
    price_low_high: "Prix: du plus bas au plus élevé",
    price_high_low: "Prix: du plus élevé au plus bas",
    name_a_z: "Nom: A-Z",
    name_z_a: "Nom: Z-A",
    newest: "Nouveautés",
    bestselling: "Meilleures ventes",
    vintage_newest: "Millésime: plus récent",
    vintage_oldest: "Millésime: plus ancien",
    // Results
    loading_products: "Chargement des produits...",
    showing_results: "Affichage de {start}-{end} sur {total} résultats",
    no_filters_available: "Aucun filtre disponible",
    lowest_price: "Prix Plus Bas",
    lowest_price_strong: "Plus Bas: ",
    lowest_price_text:
      "Il s'agit du prix le plus bas auquel le produit était en vente au cours des 30 jours précédant la réduction de prix, y compris les autres périodes promotionnelles.",
    list_price_strong: "Prix ​​catalogue :",
    list_price_text:
      "Indique le prix du produit avant le début de la promotion.",
    remaining_products: "{count} derniers produits",
    remaining_product: "Dernier produit",
    no_remaining_products: "Indisponible",
    get_notification: `<span class="default-message"><span class="fw-light">Indisponible, <span style="font-weight: 700">prévenez-moi !</span></span></span>`,
    express_shipping: `<span class="default-message"><span class="fw-light"><span style="font-weight: 700">Livraison express</span></span></span>`,
    preorder: `<span class="default-message"><span class="fw-light">Précommander</span>`,
    preorder_by: `<span class="default-message"><span class="fw-light">Précommander avant le <span style="font-weight: 700">{date}</span></span>`,
    quantity_discount: "Remise quantité",
  },
  de: {
    no_products_found: "Keine Produkte gefunden",
    no_products_in_collection: "Es gibt keine Produkte in dieser Kollektion aktuell.",
    try_changing_filters: "Versuchen Sie, die Filter zu ändern, um mehr Produkte zu sehen.",
    clear_filters: "Filter löschen",
    // Filters
    filters_title: "Filter",
    price: "Preis",
    price_up_to: "Bis zu",
    price_from_to: "Von {min} bis {max}",
    price_over: "Über",
    apply: "Anwenden",
    clear_all_filters: "Alle Filter löschen",
    active_filters: "Aktive Filter:",
    tipologia: "Typologie",
    formato: "Format",
    vitigni: "Rebsorten",
    paese: "Land",
    regioni: "Regionen",
    back_to_countries: "Zurück zu Ländern",
    appellation: "Herkunftsbezeichnung",
    denominazione: "Herkunftsbezeichnung",
    sotto_denominazione: "Unter-Herkunftsbezeichnung",
    back_to_appellations: "Zurück zu Herkunftsbezeichnungen",
    back_to_formats: "Zurück zu Formaten",
    details: "Details",
    premi: "Auszeichnungen",
    filosofie: "Stil und Produktion",
    produttore: "Produzent",
    annate: "Jahrgang",
    abbinamenti: "Empfehlungen",
    add_to_cart: "In den Warenkorb",
    wishlisted_success: "wurde erfolgreich zur Wunschliste hinzugefügt",
    unwishlisted_success: "wurde erfolgreich aus der Wunschliste entfernt",
    product: "produkt",
    products: "produkte",
    awarded_by_label: "Von {guide} mit {vote} ausgezeichnet",
    award_grapes_label: " Trauben",
    award_glasses_label: " Brillen",
    award_stars_label: " Sterne",
    awards_description: {
      BB: "Leitfaden der Italian Sommelier Foundation (FIS) Dies ist seit über 10 Jahren einer der renommiertesten Weinführer Italiens.",
      DE: "Decanter ist ein Wein- und Lifestyle-Magazin, das monatlich in rund 90 Ländern erscheint. Das Magazin enthält Branchennachrichten, klassische Ratgeber und Ratschläge zu Wein und Spirituosen.",
      RP: "Der renommierte internationale Weinführer des renommierten Robert Parker, dem erfahrensten und vertrauenswürdigsten Weinverkoster der Welt.",
      LM: "Einer der renommiertesten Weinführer Italiens.",
      GR: "Dieser Führer genießt hohes Ansehen und bietet den umfassendsten Überblick über italienische Weine. Er hat eine lange Tradition und basiert auf Blindverkostungen, die von über 100 Experten durchgeführt werden.",
      VR: "Einer der renommiertesten Weinführer Italiens.",
      VT: "Leitfaden der Italian Sommelier Association (AIS)",
      VO: "Vinous ist der Online-Guide von Antonio Galloni, einem der weltweit führenden Weinkenner.",
      WS: "Wine Spectator ist der einflussreichste Weinführer im Internet.",
      SL: "",
      XW: "",
      HC: "Der ultimative Leitfaden zu französischen Weinen.",
      JS: "James Suckling ist ein einflussreicher amerikanischer Weinkritiker und Journalist, der 30 Jahre lang für den Wine Spectator arbeitete. 2010 verließ er das Magazin, um seine eigene Website und seinen eigenen Reiseführer (JamesSuckling.com) zu starten. Er ist auf italienische und Bordeaux-Weine spezialisiert.",
    },
    // Active filters
    filter_names: {
      vendor: "Produzent",
      category: "Kategorie",
      grapes: "Rebsorten",
      region: "Region",
      awards: "Auszeichnungen",
      philosophy: "Stil und Produktion",
      dosage: "Dosierung",
      vintage: "Jahrgang",
      alcohol: "Alkoholgehalt",
      sub_category: "Methode",
      price_range: "Preis",
      remove_filter: "Filter entfernen",
      clear_all: "Alle löschen",
      no_year: "Ohne Jahrgang",
      // Search placeholders
      search_awards: "Auszeichnungen suchen...",
      search_appellations: "Appellationen suchen...",
      search_subappellations: "Unter-Appellationen suchen...",
      search_dosage: "Dosierung suchen...",
      search_grapes: "Rebsorten suchen...",
      search_philosophy: "Achten Sie auf Stil und Produktion...",
      search_producers: "Produzenten suchen...",
      search_pairings: "Empfehlungen suchen...",
      search_vintage: "Jahrgang suchen...",
      search_alcohol: "Alkohol suchen...",
      search_sub_category: "Methode suchen...",
      search_format: "Format suchen...",
      search_formatdescription: "Format Beschreibung suchen...",
      // No results messages
      no_awards_found: "Keine Auszeichnungen gefunden",
      no_appellations_found: "Keine Appellationen gefunden",
      no_subappellations_found: "Keine Unter-Appellationen gefunden",
      no_dosage_found: "Keine Dosierung gefunden",
      no_grapes_found: "Keine Rebsorten gefunden",
      no_philosophy_found: "Kein Stil und/oder keine Produktion gefunden",
      no_producers_found: "Keine Produzenten gefunden",
      no_pairings_found: "Keine Empfehlungen gefunden",
      no_vintage_found: "Kein Jahrgang gefunden",
      no_alcohol_found: "Kein Alkoholgehalt gefunden",
      no_sub_category_found: "Keine Methode gefunden",
      no_format_found: "Kein Format gefunden",
      no_formatdescription_found: "Keine Format Beschreibung gefunden",
      // Load more functionality
      load_more: "Mehr laden",
      show_less: "Weniger anzeigen",
      load_more_count: "Mehr laden ({count} verbleibend)",
      showing_all: "Alle anzeigen",
    },
    categories: {
      red_wine: "Rotwein",
      white_wine: "Weißwein",
      rose_wine: "Roséwein",
      champagne_sparkling_wine: "Sekt & Champagner",
      champagne: "Champagne",
      sparkling_wine: "Sekt & Champagner",
      spirits: "Spirituosen",
      // Spirits specifici
      dessert: "Dessertweine",
      gin: "Gin",
      whisky: "Whisky",
      grappa: "Grappa",
      rum: "Rum",
      fortified: "Likörweine",
      liqueurs: "Liköre",
      bitter_liqueur: "Bitterliköre",
      vermouth: "Wermut",
      other_spirits: "Andere Spirituosen",
      vodka: "Wodka",
      cognac: "Cognac",
      tequila: "Tequila",
      cocktail: "Cocktail",
      cider: "Apfelwein",
      sake: "Sake",
      absinthe: "Absinth",
      brandy: "Brandy",
      calvados: "Calvados",
      // Accessori
      corkscrews: "Korkenzieher",
      wine_stoppers: "Weinverschlüsse",
      other: "Andere",
      cleaning: "Reinigung",
      sets: "Sets",
      bags_containers: "Taschen & Behälter",
      wine_cooling: "Weinkühlung",
    },
    grapes: {
      "Blend Red": "Rote blend",
      "Blend White": "Weiße blend",
    },
    awards: {
      "Gambero Rosso 3 glasses": "Gambero Rosso 3 Gläser",
      "Bibenda 4 bunches": "Bibenda 4 Trauben",
      "Bibenda 5 bunches": "Bibenda 5 Trauben",
      "Veronelli 3 red stars": "Veronelli 3 rote Sterne",
      "Vitae AIS 4 vines": "Vitae AIS 4 Reben",
      "Vitae AIS 3 vines": "Vitae AIS 3 Reben",
      "Gambero Rosso 2 glasses": "Gambero Rosso 2 Gläser",
      "Veronelli 3 gold stars": "Veronelli 3 goldene Sterne",
      "Hachette 2 stars": "Hachette 2 Sterne",
      "Hachette 3 stars": "Hachette 3 Sterne",
    },
    formats: {
      Standard: "Standard",
      Big: "Große",
      Small: "Klein",
    },
    regions: {
      Tuscany: "Toskana",
      Piedmont: "Piemont",
      Burgundy: "Burgund",
      Bordeaux: "Bordeaux",
      "Rhone Valley": "Rhônetal",
      Mendoza: "Mendoza",
      California: "Kalifornien",
      Beaujolais: "Beaujolais",
      "South Africa": "Südafrika",
      Rioja: "Rioja",
      Loire: "Loire",
      Jura: "Jura",
      "Uco Valley": "Uco Valley",
      "Castile and León": "Kastilien und León",
      Catalonia: "Katalonien",
      Galicia: "Galicien",
      "Maipo Valley": "Maipo Valley",
      "New Zealand": "Neuseeland",
      "Champagne region": "Champagne-Gebiet",
      "Colchagua Valley": "Colchagua Valley",
      "Barossa Valley": "Barossa Valley",
      "South Australia": "Südaustralien",
      "South West": "Südwesten",
      "Valle de Cafayate": "Valle de Cafayate",
      Alsace: "Elsass",
      "Rapel Valley": "Rapel Valley",
      Navarre: "Navarra",
      Provence: "Provence",
      Savoy: "Savoyen",
      "Western Australia": "Westaustralien",
      "Aconcagua Valley": "Aconcagua Valley",
      "Bekaa Valley": "Bekaa Valley",
      "Canary Islands": "Kanarische Inseln",
      "Casablanca Valley": "Casablanca Valley",
      "Maule Valley": "Maule Valley",
      Switzerland: "Schweiz",
      "Languedoc-Roussillon": "Languedoc-Roussillon",
      "Trentino Alto Adige": "Trentino-Südtirol",
      Veneto: "Venetien",
      "Friuli-Venezia Giulia": "Friaul-Julisch Venetien",
      Lombardy: "Lombardei",
      Sicily: "Sizilien",
      "Emilia-Romagna": "Emilia-Romagna",
      Apulia: "Apulien",
      Marche: "Marken",
      Campania: "Kampanien",
      Abruzzo: "Abruzzen",
      Sardinia: "Sardinien",
      Umbria: "Umbrien",
      Liguria: "Ligurien",
      "Aosta Valley": "Aostatal",
      Lazio: "Latium",
      Calabria: "Kalabrien",
      Basilicata: "Basilikata",
      Molise: "Molise",
      Germany: "Deutschland",
    },
    countries: {
      Italy: "Italien",
      France: "Frankreich",
      Germany: "Deutschland",
      Spain: "Spanien",
      "United Kingdom": "Vereinigtes Königreich",
      Argentina: "Argentinien",
      "United States of America": "Vereinigte Staaten von Amerika",
      "South Africa": "Südafrika",
      "Carribean Sea": "Karibik",
      "New Zealand": "Neuseeland",
      Japan: "Japan",
      Portugal: "Portugal",
      Slovenia: "Slowenien",
      Chile: "Chile",
      Austria: "Österreich",
      Australia: "Australien",
      Hungary: "Ungarn",
      Netherlands: "Niederlande",
      Venezuela: "Venezuela",
      Mexico: "Mexiko",
      Uruguay: "Uruguay",
      Armenia: "Armenien",
      "Canary Islands": "Kanarische Inseln",
      India: "Indien",
      Sweden: "Schweden",
      Switzerland: "Schweiz",
      Greece: "Griechenland",
      Ireland: "Irland",
      Lebanon: "Libanon",
      Taiwan: "Taiwan",
      Belgium: "Belgien",
      Brazil: "Brasilien",
      China: "China",
      Croatia: "Kroatien",
      "Czech Republic": "Tschechische Republik",
      Guatemala: "Guatemala",
      Norway: "Norwegen",
      Philippines: "Philippinen",
      Poland: "Polen",
      Russia: "Russland",
      Israel: "Israel",
    },
    alcohol: {
      "Between 13.6-15.9%": "Zwischen 13.6-15.9%",
      "Between 12.5-13.5%": "Zwischen 12.5-13.5%",
      "Less than 12.5%": "Weniger als 12.5%",
      "16% or more": "16 % oder mehr",
      "Zero alcohol": "Alkoholfrei",
      "Between 40 - 50%": "Zwischen 40 - 50%",
      "Between 30 - 40%": "Zwischen 30 - 40%",
      "50% or more": "50 % oder mehr",
      "Between 20 - 30%": "Zwischen 20 - 30%",
      "Less than 20%": "Weniger als 20%",
    },
    philosophies: {
      Artisan: "Aus eigener Herstellung",
      "Certified Biodynamic": "Biodynamisch zertifiziert",
      "Certified Organic": "Bio zertifiziert",
      "Drained barrels or Solera method":
        "Teilgefüllte Fässer oder Solera-System",
      "Heroic viticulture": "Heroischer Weinbau",
      "In amphora": "In der Amphore",
      "In cement vats": "In Betonbehältern",
      "Independent winemaker": "Unabhängige Winzer",
      "Indigenous yeasts": "Heimische Hefen",
      Kosher: "Kosher",
      "Macerated on the skins": "Auf Schalen mazeriert",
      "Naturally re-fermented": "Natürliche Flaschengärung",
      "No added sulphites or minimal sulphites":
        "Ohne oder geringer Schwefelzusatz",
      "Old vines (+ 40 years)": "Alte Rebstöcke (+ 40 Jahre)",
      "Orange Wine": "Orange Wine",
      "Oxidative style": "Oxidativer Ausbau",
      "Recoltant Manipulant": "Récoltant Manipulant",
      "Triple A": "Triple A",
      Vegan: "Vegan",
      "Zero filtration": "Ohne Filtration",
    },
    pairings: {
      Cheese: "Käse",
      Meat: "Fleisch",
      Fish: "Fisch",
      Starters: "Vorspeisen",
      Pasta: "Pasta",
      "Vegetarian dishes": "Vegetarische Gerichte",
      "Sweets and Desserts": "Süßigkeiten und Desserts",
      "Spicy food": "Scharfes Essen",
      Pizza: "Pizza",
    },
    sub_categories: {
      "Ancestral Method": "Méthode Ancestrale",
      "Apple cider": "Apfelwein",
      Aromatised: "Aromatisiert",
      Beer: "Bier",
      "Blanc de Blancs": "Blanc Blanc de Blancs",
      "Blanc de Noirs": "Blanc Blanc de Noirs",
      "Blended Whisky": "Blended Whisky",
      "Bourbon Straight Whisky": "Bourbon Bourbon Straight Whisky",
      "Bourbon Whisky": "Bourbon Whisky",
      Bubbly: "Perlwein",
      "Charmat Method": "Charmat-Methode",
      Classic: "Klassisch",
      "Classic Method": "Traditionelle Methode",
      Dessert: "Strohwein",
      "Dessert from grapes with noble rot":
        "Dessert from grapes with Strohwein aus Trauben mit Edelfäule",
      "Foam packaging": "Verpackung aus Polystyrol",
      Fortified: "Likörwein",
      Fruit: "Frucht",
      "Genever or Dutch Gin": "Genever or Genever or Dutch Gin",
      Gin: "Gin",
      "Grain Whisky": "Grain Whisky",
      "Grand Cru": "Grand Cru",
      "Irish Whisky": "Irish Whisky",
      "Japanese Whisky": "Japanese Whisky",
      "Late harvest dessert": "Late Spätlese-Strohwein",
      "London Dry Gin": "London London Dry Gin",
      "Malt Whisky": "Malt Whisky",
      Millesimé: "Millésime",
      "Old Tom Gin": "Old Old Tom Gin",
      Others: "Andere",
      "Plymouth Gin": "Plymouth Gin",
      "Premier Cru": "Premier Cru",
      Riserva: "Reserve",
      "Rye Whisky": "Rye Whisky",
      "Sans Année": "Sans Année",
      "Scotch Whisky": "Scotch Whisky",
      "Single malt Whisky": "Single Single malt Whisky",
      Still: "Stillwein",
      Superiore: "Superiore",
      "Tennessee Whiskey": "Tennessee Whiskey",
      Whisky: "Whisky",
      "Whisky Liqueurs": "Whisky Liqueurs",
    },

    // Sorting
    sort_by: "Sortieren nach:",
    popularity: "Beliebtheit",
    new_in: "Neuheiten",
    hk_available: "Sofortige Verfügbarkeit",
    most_awarded: "Meist Ausgezeichnet",
    on_sale: "Im Angebot",
    best_selling: "Bestseller",
    most_discounted: "Meist Reduziert",
    lowest_price: "Niedrigster Preis",
    highest_price: "Höchster Preis",
    newest_vintage: "Neuester Jahrgang",
    oldest_vintage: "Ältester Jahrgang",
    // Legacy translations (for backward compatibility)
    relevance: "Beliebtheit",
    price_low_high: "Preis: Niedrig zu Hoch",
    price_high_low: "Preis: Hoch zu Niedrig",
    name_a_z: "Name: A-Z",
    name_z_a: "Name: Z-A",
    newest: "Neueste",
    bestselling: "Bestseller",
    vintage_newest: "Jahrgang: Neueste",
    vintage_oldest: "Jahrgang: Älteste",

    // Results
    loading_products: "Produkte werden geladen...",
    showing_results: "Zeige {start}-{end} von {total} Ergebnissen",
    no_filters_available: "Keine Filter verfügbar",
    lowest_price: "Niedrigster Preis",
    lowest_price_strong: "Niedrigster: ",
    lowest_price_text:
      "Dies ist der niedrigste Preis, zu dem das Produkt in den 30 Tagen vor der Preissenkung, einschließlich anderer Aktionszeiträume, im Angebot war.",
    list_price_strong: "Listenpreis:",
    list_price_text:
      "Zeigt den Preis des Produkts vor Beginn der Werbeaktion an.",
    remaining_products: "Letzte {count} Produkte",
    remaining_product: "Letztes verfügbares Produkt",
    no_remaining_products: "Nicht verfügbar",
    get_notification: `<span class="default-message"><span class="fw-light">Nicht verfügbar, <span style="font-weight: 700">benachrichtigen Sie mich!</span></span></span>`,
    express_shipping: `<span class="default-message"><span class="fw-light"><span style="font-weight: 700">Expressversand</span></span></span>`,
    preorder: `<span class="default-message"><span class="fw-light">Vorbestellen</span>`,
    preorder_by: `<span class="default-message"><span class="fw-light">Vorbestellen bis <span style="font-weight: 700">{date}</span></span>`,
    quantity_discount: "Mengenrabatt",
  },
  es: {
    no_products_found: "No se encontraron productos",
    no_products_in_collection: "No hay productos en esta colección actualmente.",
    try_changing_filters: "Intenta cambiar los filtros para ver más productos.",
    clear_filters: "Borrar filtros",
    // Filters
    filters_title: "Filtros",
    price: "Precio",
    price_up_to: "Hasta",
    price_from_to: "De {min} a {max}",
    price_over: "Más de",
    apply: "Aplicar",
    clear_all_filters: "Eliminar todos los filtros",
    active_filters: "Filtros activos:",
    tipologia: "Tipología",
    formato: "Formato",
    vitigni: "Variedades de uva",
    paese: "País",
    regioni: "Regiones",
    back_to_countries: "Volver a Países",
    appellation: "Denominación",
    denominazione: "Denominación",
    sotto_denominazione: "Sub-Denominación",
    back_to_appellations: "Volver a Denominaciones",
    back_to_formats: "Volver a Formatos",
    details: "Detalles",
    premi: "Premios",
    filosofie: "Estilo y Producción",
    produttore: "Productor",
    annate: "Añada",
    abbinamenti: "Maridajes",
    add_to_cart: "Añadir al carrito",
    wishlisted_success: "se ha añadido a la lista de deseos con éxito",
    unwishlisted_success: "ha sido eliminado de la lista de deseos con éxito",
    product: "producto",
    products: "productos",
    awarded_by_label: "Premiado {vote} por {guide}",
    award_grapes_label: " uvas",
    award_glasses_label: " vasos",
    award_stars_label: " estrellas",
    awards_description: {
      BB: "Guía de la Fundación Italiana del Sumiller (FIS) Desde hace más de 10 años es una de las guías de vinos más prestigiosas de Italia.",
      DE: "Decanter es una revista de vinos y estilo de vida que se publica mensualmente en unos 90 países. Incluye noticias del sector, guías clásicas y consejos sobre vinos y licores.",
      RP: "La prestigiosa guía internacional de vinos del reconocido Robert Parker, el catador más experimentado y confiable del mundo.",
      LM: "Una de las guías de vinos más prestigiosas de Italia.",
      GR: "Esta guía goza de gran prestigio y ofrece la reseña más completa de los vinos italianos. Cuenta con una larga tradición y se basa en catas a ciegas realizadas por más de 100 expertos.",
      VR: "Una de las guías de vinos más prestigiosas de Italia.",
      VT: "Guía de la Asociación Italiana de Sumilleres (AIS)",
      VO: "Vinous es la guía online de Antonio Galloni, uno de los mayores conocedores de vinos del mundo.",
      WS: "Wine Spectator es la guía de vinos más influyente en Internet.",
      SL: "",
      XW: "",
      HC: "La guía definitiva de los vinos franceses.",
      JS: "James Suckling es un influyente crítico de vinos y periodista estadounidense que trabajó en Wine Spectator durante 30 años. Dejó la revista en 2010 para crear su propio sitio web y guía (JamesSuckling.com). Se especializa en vinos italianos y de Burdeos.",
    },
    // Active filters
    filter_names: {
      vendor: "Productor",
      category: "Categoría",
      grapes: "Variedades de uva",
      region: "Región",
      awards: "Premios",
      philosophy: "Estilo y Producción",
      dosage: "Dosificación",
      vintage: "Añada",
      alcohol: "Graduación Alcohólica",
      sub_category: "Método",
      price_range: "Precio",
      remove_filter: "Eliminar filtro",
      clear_all: "Eliminar todos",
      no_year: "Sin añada",
      // Search placeholders
      search_awards: "Buscar premios...",
      search_appellations: "Buscar denominaciones...",
      search_subappellations: "Buscar sub-denominaciones...",
      search_dosage: "Buscar dosificación...",
      search_grapes: "Buscar variedades...",
      search_philosophy: "Buscar estilo y producción...",
      search_producers: "Buscar productores...",
      search_pairings: "Buscar maridajes...",
      search_vintage: "Buscar añada...",
      search_alcohol: "Buscar graduación...",
      search_sub_category: "Buscar método...",
      search_format: "Buscar formato...",
      search_formatdescription: "Buscar descripción formato...",
      // No results messages
      no_awards_found: "No se encontraron premios",
      no_appellations_found: "No se encontraron denominaciones",
      no_subappellations_found: "No se encontraron sub-denominaciones",
      no_dosage_found: "No se encontró dosificación",
      no_grapes_found: "No se encontraron variedades",
      no_philosophy_found: "No se encontró estilo y producción",
      no_producers_found: "No se encontraron productores",
      no_pairings_found: "No se encontraron maridajes",
      no_vintage_found: "No se encontró añada",
      no_alcohol_found: "No se encontró graduación alcohólica",
      no_sub_category_found: "No se encontró método",
      no_format_found: "No se encontró formato",
      no_formatdescription_found: "No se encontró descripción formato",
      // Load more functionality
      load_more: "Cargar más",
      show_less: "Mostrar menos",
      load_more_count: "Cargar más ({count} restantes)",
      showing_all: "Mostrando todos",
    },
    categories: {
      red_wine: "Vino Tinto",
      white_wine: "Vino Blanco",
      rose_wine: "Vino Rosado",
      champagne_sparkling_wine: "Champagne & Vino Espumoso",
      sparkling_wine: "Vino Espumoso",
      champagne: "Champagne",
      spirits: "Espirituosos",
      // Spirits specifici
      dessert: "Vinos de Postre",
      gin: "Ginebra",
      whisky: "Whisky",
      grappa: "Grappa",
      rum: "Ron",
      fortified: "Vinos Fortificados",
      liqueurs: "Licores",
      bitter_liqueur: "Licores Amargos",
      vermouth: "Vermut",
      other_spirits: "Otros Espirituosos",
      vodka: "Vodka",
      cognac: "Coñac",
      tequila: "Tequila",
      cocktail: "Cóctel",
      cider: "Sidra",
      sake: "Sake",
      absinthe: "Absenta",
      brandy: "Brandy",
      calvados: "Calvados",
      // Accessori
      corkscrews: "Sacacorchos",
      wine_stoppers: "Tapones de Vino",
      other: "Otro",
      cleaning: "Limpieza",
      sets: "Conjuntos",
      bags_containers: "Bolsas y Contenedores",
      wine_cooling: "Enfriamiento de Vino",
    },
    grapes: {
      "Blend Red": "Blend tinto",
      "Blend White": "Blend blanco",
    },
    awards: {
      "Gambero Rosso 3 glasses": "Gambero Rosso 3 copas",
      "Bibenda 4 bunches": "Bibenda 4 racimos",
      "Bibenda 5 bunches": "Bibenda 5 racimos",
      "Veronelli 3 red stars": "Veronelli 3 estrellas rojas",
      "Vitae AIS 4 vines": "Vitae AIS 4 vides",
      "Vitae AIS 3 vines": "Vitae AIS 3 vides",
      "Gambero Rosso 2 glasses": "Gambero Rosso 2 copas",
      "Veronelli 3 gold stars": "Veronelli 3 estrellas de oro",
      "Hachette 2 stars": "Hachette 2 estrellas",
      "Hachette 3 stars": "Hachette 3 estrellas",
    },
    formats: {
      Standard: "Standard",
      Big: "Grande",
      Small: "Pequeño",
    },
    regions: {
      Tuscany: "Toscana",
      Piedmont: "Piamonte",
      Burgundy: "Borgoña",
      Bordeaux: "Burdeos",
      "Rhone Valley": "Valle del Ródano",
      Mendoza: "Mendoza",
      California: "California",
      Beaujolais: "Beaujolais",
      "South Africa": "Sudáfrica",
      Rioja: "Rioja",
      Loire: "Loira",
      Jura: "Jura",
      "Uco Valley": "Valle de Uco",
      "Castile and León": "Castilla y León",
      Catalonia: "Cataluña",
      Galicia: "Galicia",
      "Maipo Valley": "Valle del Maipo",
      "New Zealand": "Nueva Zelanda",
      "Champagne region": "Región de Champaña",
      "Colchagua Valley": "Valle de Colchagua",
      "Barossa Valley": "Valle de Barossa",
      "South Australia": "Australia del Sur",
      "South West": "Suroeste",
      "Valle de Cafayate": "Valle de Cafayate",
      Alsace: "Alsacia",
      "Rapel Valley": "Valle de Rapel",
      Navarre: "Navarra",
      Provence: "Provenza",
      Savoy: "Saboya",
      "Western Australia": "Australia Occidental",
      "Aconcagua Valley": "Valle de Aconcagua",
      "Bekaa Valley": "Valle de la Bekaa",
      "Canary Islands": "Islas Canarias",
      "Casablanca Valley": "Valle de Casablanca",
      "Maule Valley": "Valle del Maule",
      Switzerland: "Suiza",
      "Languedoc-Roussillon": "Languedoc-Rosellón",
      "Trentino Alto Adige": "Trentino-Alto Adigio",
      Veneto: "Véneto",
      "Friuli-Venezia Giulia": "Friuli-Venecia Julia",
      Lombardy: "Lombardía",
      Sicily: "Sicilia",
      "Emilia-Romagna": "Emilia-Romaña",
      Apulia: "Apulia",
      Marche: "Marcas",
      Campania: "Campania",
      Abruzzo: "Abruzos",
      Sardinia: "Cerdeña",
      Umbria: "Umbría",
      Liguria: "Liguria",
      "Aosta Valley": "Valle de Aosta",
      Lazio: "Lacio",
      Calabria: "Calabria",
      Basilicata: "Basilicata",
      Molise: "Molise",
      Germany: "Alemania",
    },
    countries: {
      Italy: "Italia",
      France: "Francia",
      Germany: "Alemania",
      Spain: "España",
      "United Kingdom": "Reino Unido",
      Argentina: "Argentina",
      "United States of America": "Estados Unidos de América",
      "South Africa": "Sudáfrica",
      "Carribean Sea": "Mar Caribe",
      "New Zealand": "Nueva Zelanda",
      Japan: "Japón",
      Portugal: "Portugal",
      Slovenia: "Eslovenia",
      Chile: "Chile",
      Austria: "Austria",
      Australia: "Australia",
      Hungary: "Hungría",
      Netherlands: "Países Bajos",
      Venezuela: "Venezuela",
      Mexico: "México",
      Uruguay: "Uruguay",
      Armenia: "Armenia",
      "Canary Islands": "Islas Canarias",
      India: "India",
      Sweden: "Suecia",
      Switzerland: "Suiza",
      Greece: "Grecia",
      Ireland: "Irlanda",
      Lebanon: "Líbano",
      Taiwan: "Taiwán",
      Belgium: "Bélgica",
      Brazil: "Brasil",
      China: "China",
      Croatia: "Croacia",
      "Czech Republic": "República Checa",
      Guatemala: "Guatemala",
      Norway: "Noruega",
      Philippines: "Filipinas",
      Poland: "Polonia",
      Russia: "Rusia",
      Israel: "Israel",
    },
    alcohol: {
      "Between 13.6-15.9%": "Entre 13.6-15.9%",
      "Between 12.5-13.5%": "Entre 12.5-13.5%",
      "Less than 12.5%": "Menos del 12.5%",
      "16% or more": "16 % o más",
      "Zero alcohol": "Sin alcohol",
      "Between 40 - 50%": "Entre 40 - 50%",
      "Between 30 - 40%": "Entre 30 - 40%",
      "50% or more": "50 % o más",
      "Between 20 - 30%": "Entre 20 - 30%",
      "Less than 20%": "Menos del 20%",
    },
    philosophies: {
      Artisan: "Artesanales",
      "Certified Biodynamic": "Biodinámicos certificados",
      "Certified Organic": "Biológicos certificados",
      "Drained barrels or Solera method": "Botas en hiladas o Solera",
      "Heroic viticulture": "Viticultura heroica",
      "In amphora": "En ánfora",
      "In cement vats": "En cubas de cemento",
      "Independent winemaker": "Viticultor independiente",
      "Indigenous yeasts": "Levaduras indígenas",
      Kosher: "Kosher",
      "Macerated on the skins": "Con maceración pelicular",
      "Naturally re-fermented": "Refermentados naturalmente",
      "No added sulphites or minimal sulphites":
        "Sin sulfitos añadidos o mínimos",
      "Old vines (+ 40 years)": "Viñedos viejos (+ 40 años)",
      "Orange Wine": "Orange Wine",
      "Oxidative style": "Estilo oxidativo",
      "Recoltant Manipulant": "Recoltant Manipulant",
      "Triple A": "Triple A",
      Vegan: "Veganos",
      "Zero filtration": "Sin filtrar",
    },
    pairings: {
      Cheese: "Queso",
      Meat: "Carne",
      Fish: "Pescado",
      Starters: "Entrantes",
      Pasta: "Pasta",
      "Vegetarian dishes": "Platos vegetarianos",
      "Sweets and Desserts": "Dulces y postres",
      "Spicy food": "Comida picante",
      Pizza: "Pizza",
    },
    sub_categories: {
      "Ancestral Method": "Método Ancestral",
      "Apple cider": "Apple cider",
      Aromatised: "Aromatizado",
      Beer: "Beer",
      "Blanc de Blancs": "Blanc Blanc de Blancs",
      "Blanc de Noirs": "Blanc Blanc de Noirs",
      "Blended Whisky": "Blended Whisky",
      "Bourbon Straight Whisky": "Bourbon Bourbon Straight Whisky",
      "Bourbon Whisky": "Bourbon Whisky",
      Bubbly: "Con burbujas",
      "Charmat Method": "Método Charmat",
      Classic: "Clásico",
      "Classic Method": "Método Champenoise",
      Dessert: "Vino de pasas",
      "Dessert from grapes with noble rot":
        "Dessert from grapes with Vino de pasas con podredumbre noble",
      "Foam packaging": "Embalajes de poliestireno",
      Fortified: "Licorosos",
      Fruit: "Fruit",
      "Genever or Dutch Gin": "Genever or Genever or Dutch Gin",
      Gin: "Gin",
      "Grain Whisky": "Grain Whisky",
      "Grand Cru": "Grand Cru",
      "Irish Whisky": "Irish Whisky",
      "Japanese Whisky": "Japanese Whisky",
      "Late harvest dessert": "Late Vino de pasas vendimia tardía",
      "London Dry Gin": "London London Dry Gin",
      "Malt Whisky": "Malt Whisky",
      Millesimé: "Milésimato",
      "Old Tom Gin": "Old Old Tom Gin",
      Others: "Others",
      "Plymouth Gin": "Plymouth Gin",
      "Premier Cru": "Premier Cru",
      Riserva: "Reserva",
      "Rye Whisky": "Rye Whisky",
      "Sans Année": "Sans Année",
      "Scotch Whisky": "Scotch Whisky",
      "Single malt Whisky": "Single Single malt Whisky",
      Still: "Tranquilo",
      Superiore: "Superior",
      "Tennessee Whiskey": "Tennessee Whiskey",
      Whisky: "Whisky",
      "Whisky Liqueurs": "Whisky Liqueurs",
    },

    // Sorting
    sort_by: "Ordenar por:",
    popularity: "Popularidad",
    new_in: "Novedades",
    hk_available: "Disponibilidad inmediata",
    most_awarded: "Más Premiados",
    on_sale: "En Oferta",
    best_selling: "Más vendidos",
    most_discounted: "Más Rebajados",
    lowest_price: "Precio Más Bajo",
    highest_price: "Precio Más Alto",
    newest_vintage: "Añada Más Reciente",
    oldest_vintage: "Añada Más Antigua",
    // Legacy translations (for backward compatibility)
    relevance: "Popularidad",
    price_low_high: "Precio: de menor a mayor",
    price_high_low: "Precio: de mayor a menor",
    name_a_z: "Nombre: A-Z",
    name_z_a: "Nombre: Z-A",
    newest: "Más recientes",
    bestselling: "Más vendidos",
    vintage_newest: "Añada: más reciente",
    vintage_oldest: "Añada: más antigua",

    // Results
    loading_products: "Cargando productos...",
    showing_results: "Mostrando {start}-{end} de {total} resultados",
    no_filters_available: "No hay filtros disponibles",
    lowest_price: "Precio Más Bajo",
    lowest_price_strong: "Más Bajo: ",
    lowest_price_text:
      "Es el precio más bajo al que el producto estuvo a la venta durante los 30 días anteriores a la reducción de precio, incluyendo otros períodos promocionales.",
    list_price_strong: "Precio de lista:",
    list_price_text:
      "Indica el precio del producto antes del inicio de la promoción.",
    remaining_products: "Últimos {count} productos",
    remaining_product: "Último producto",
    no_remaining_products: "No disponible",
    get_notification: `<span class="default-message"><span class="fw-light">No disponible, <span style="font-weight: 700">¡avísame!</span></span></span>`,
    express_shipping: `<span class="default-message"><span class="fw-light"><span style="font-weight: 700">Envío exprés</span></span></span>`,
    preorder: `<span class="default-message"><span class="fw-light">Reserva</span>`,
    preorder_by: `<span class="default-message"><span class="fw-light">Reservar antes del <span style="font-weight: 700">{date}</span></span>`,
    quantity_discount: "Descuento de cantidad",
  },
};

// Collection page translations
AlgoliaTranslations.CollectionIT = ALGOLIA_TRANSLATIONS_COLLECTION.it;
AlgoliaTranslations.CollectionEN = ALGOLIA_TRANSLATIONS_COLLECTION.en;
AlgoliaTranslations.CollectionFR = ALGOLIA_TRANSLATIONS_COLLECTION.fr;
AlgoliaTranslations.CollectionDE = ALGOLIA_TRANSLATIONS_COLLECTION.de;
AlgoliaTranslations.CollectionES = ALGOLIA_TRANSLATIONS_COLLECTION.es;
AlgoliaTranslations.CollectionZH = ALGOLIA_TRANSLATIONS_COLLECTION.zh;
